import type { DocumentNode } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Address: { input: string; output: string; }
  AssetId: { input: string; output: string; }
  BlobId: { input: any; output: any; }
  BlockId: { input: string; output: string; }
  Bytes32: { input: string; output: string; }
  ContractId: { input: string; output: string; }
  HexString: { input: string; output: string; }
  Nonce: { input: string; output: string; }
  RelayedTransactionId: { input: string; output: string; }
  Salt: { input: string; output: string; }
  Signature: { input: string; output: string; }
  SubId: { input: string; output: string; }
  Tai64Timestamp: { input: string; output: string; }
  TransactionId: { input: string; output: string; }
  TxPointer: { input: string; output: string; }
  U16: { input: string; output: string; }
  U32: { input: string; output: string; }
  U64: { input: string; output: string; }
  U128: { input: string; output: string; }
  UtxoId: { input: string; output: string; }
};

export type GqlAccount = {
  address?: InputMaybe<Scalars['Address']['input']>;
  predicate?: InputMaybe<GqlPredicate>;
};

export type GqlAssembleTransactionResult = {
  gasPrice: Scalars['U64']['output'];
  status: GqlDryRunTransactionStatus;
  transaction: GqlTransaction;
};

export type GqlAssetInfoDetails = {
  contractId: Scalars['ContractId']['output'];
  subId: Scalars['SubId']['output'];
  totalSupply: Scalars['U128']['output'];
};

export type GqlBalance = {
  amount: Scalars['U64']['output'];
  amountU128: Scalars['U128']['output'];
  assetId: Scalars['AssetId']['output'];
  owner: Scalars['Address']['output'];
};

export type GqlBalanceConnection = {
  /** A list of edges. */
  edges: Array<GqlBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<GqlBalance>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlBalanceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GqlBalance;
};

export type GqlBalanceFilterInput = {
  /** Filter coins based on the `owner` field */
  owner: Scalars['Address']['input'];
};

export type GqlBlob = {
  bytecode: Scalars['HexString']['output'];
  id: Scalars['BlobId']['output'];
};

export type GqlBlock = {
  consensus: GqlConsensus;
  header: GqlHeader;
  height: Scalars['U32']['output'];
  id: Scalars['BlockId']['output'];
  transactionIds: Array<Scalars['TransactionId']['output']>;
  transactions: Array<GqlTransaction>;
  version: GqlBlockVersion;
};

export type GqlBlockConnection = {
  /** A list of edges. */
  edges: Array<GqlBlockEdge>;
  /** A list of nodes. */
  nodes: Array<GqlBlock>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlBlockEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GqlBlock;
};

export enum GqlBlockVersion {
  V1 = 'V1'
}

/** Breakpoint, defined as a tuple of contract ID and relative PC offset inside it */
export type GqlBreakpoint = {
  contract: Scalars['ContractId']['input'];
  pc: Scalars['U64']['input'];
};

export type GqlChainInfo = {
  consensusParameters: GqlConsensusParameters;
  daHeight: Scalars['U64']['output'];
  gasCosts: GqlGasCosts;
  latestBlock: GqlBlock;
  name: Scalars['String']['output'];
};

export type GqlChangeOutput = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  to: Scalars['Address']['output'];
};

export type GqlChangePolicy = {
  /**
   * Adds `Output::Change` to the transaction if it is not already present.
   * Sending remaining assets to the provided address.
   */
  change?: InputMaybe<Scalars['Address']['input']>;
  /** Destroys the remaining assets by the transaction for provided address. */
  destroy?: InputMaybe<GqlDestroy>;
};

export type GqlCoin = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  /** TxPointer - the height of the block this coin was created in */
  blockCreated: Scalars['U32']['output'];
  owner: Scalars['Address']['output'];
  /** TxPointer - the index of the transaction that created this coin */
  txCreatedIdx: Scalars['U16']['output'];
  utxoId: Scalars['UtxoId']['output'];
};

export type GqlCoinConnection = {
  /** A list of edges. */
  edges: Array<GqlCoinEdge>;
  /** A list of nodes. */
  nodes: Array<GqlCoin>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlCoinEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GqlCoin;
};

export type GqlCoinFilterInput = {
  /** Returns coins only with `asset_id`. */
  assetId?: InputMaybe<Scalars['AssetId']['input']>;
  /** Returns coins owned by the `owner`. */
  owner: Scalars['Address']['input'];
};

export type GqlCoinOutput = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  to: Scalars['Address']['output'];
};

/** The schema analog of the [`coins::CoinType`]. */
export type GqlCoinType = GqlCoin | GqlMessageCoin;

export type GqlConsensus = GqlGenesis | GqlPoAConsensus;

export type GqlConsensusParameters = {
  baseAssetId: Scalars['AssetId']['output'];
  blockGasLimit: Scalars['U64']['output'];
  blockTransactionSizeLimit: Scalars['U64']['output'];
  chainId: Scalars['U64']['output'];
  contractParams: GqlContractParameters;
  feeParams: GqlFeeParameters;
  gasCosts: GqlGasCosts;
  predicateParams: GqlPredicateParameters;
  privilegedAddress: Scalars['Address']['output'];
  scriptParams: GqlScriptParameters;
  txParams: GqlTxParameters;
  version: GqlConsensusParametersVersion;
};

export type GqlConsensusParametersPurpose = {
  checksum: Scalars['Bytes32']['output'];
  witnessIndex: Scalars['U16']['output'];
};

export enum GqlConsensusParametersVersion {
  V1 = 'V1'
}

export type GqlContract = {
  bytecode: Scalars['HexString']['output'];
  id: Scalars['ContractId']['output'];
  salt: Scalars['Salt']['output'];
};

export type GqlContractBalance = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  contract: Scalars['ContractId']['output'];
};

export type GqlContractBalanceConnection = {
  /** A list of edges. */
  edges: Array<GqlContractBalanceEdge>;
  /** A list of nodes. */
  nodes: Array<GqlContractBalance>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlContractBalanceEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GqlContractBalance;
};

export type GqlContractBalanceFilterInput = {
  /** Filter assets based on the `contractId` field */
  contract: Scalars['ContractId']['input'];
};

export type GqlContractCreated = {
  contract: Scalars['ContractId']['output'];
  stateRoot: Scalars['Bytes32']['output'];
};

export type GqlContractOutput = {
  balanceRoot: Scalars['Bytes32']['output'];
  inputIndex: Scalars['U16']['output'];
  stateRoot: Scalars['Bytes32']['output'];
};

export type GqlContractParameters = {
  contractMaxSize: Scalars['U64']['output'];
  maxStorageSlots: Scalars['U64']['output'];
  version: GqlContractParametersVersion;
};

export enum GqlContractParametersVersion {
  V1 = 'V1'
}

export type GqlDaCompressedBlock = {
  bytes: Scalars['HexString']['output'];
};

export type GqlDependentCost = GqlHeavyOperation | GqlLightOperation;

export enum GqlDestroy {
  Destroy = 'DESTROY'
}

export type GqlDryRunFailureStatus = {
  programState?: Maybe<GqlProgramState>;
  reason: Scalars['String']['output'];
  receipts: Array<GqlReceipt>;
  totalFee: Scalars['U64']['output'];
  totalGas: Scalars['U64']['output'];
};

export type GqlDryRunStorageReads = {
  storageReads: Array<GqlStorageReadReplayEvent>;
  txStatuses: Array<GqlDryRunTransactionExecutionStatus>;
};

export type GqlDryRunSuccessStatus = {
  programState?: Maybe<GqlProgramState>;
  receipts: Array<GqlReceipt>;
  totalFee: Scalars['U64']['output'];
  totalGas: Scalars['U64']['output'];
};

export type GqlDryRunTransactionExecutionStatus = {
  id: Scalars['TransactionId']['output'];
  receipts: Array<GqlReceipt>;
  status: GqlDryRunTransactionStatus;
};

export type GqlDryRunTransactionStatus = GqlDryRunFailureStatus | GqlDryRunSuccessStatus;

export type GqlEstimateGasPrice = {
  gasPrice: Scalars['U64']['output'];
};

export type GqlExcludeInput = {
  /** Messages to exclude from the selection. */
  messages: Array<Scalars['Nonce']['input']>;
  /** Utxos to exclude from the selection. */
  utxos: Array<Scalars['UtxoId']['input']>;
};

export type GqlFailureStatus = {
  block: GqlBlock;
  blockHeight: Scalars['U32']['output'];
  programState?: Maybe<GqlProgramState>;
  reason: Scalars['String']['output'];
  receipts: Array<GqlReceipt>;
  time: Scalars['Tai64Timestamp']['output'];
  totalFee: Scalars['U64']['output'];
  totalGas: Scalars['U64']['output'];
  transaction: GqlTransaction;
  transactionId: Scalars['TransactionId']['output'];
};

export type GqlFeeParameters = {
  gasPerByte: Scalars['U64']['output'];
  gasPriceFactor: Scalars['U64']['output'];
  version: GqlFeeParametersVersion;
};

export enum GqlFeeParametersVersion {
  V1 = 'V1'
}

export type GqlGasCosts = {
  add: Scalars['U64']['output'];
  addi: Scalars['U64']['output'];
  aloc: Scalars['U64']['output'];
  alocDependentCost: GqlDependentCost;
  and: Scalars['U64']['output'];
  andi: Scalars['U64']['output'];
  bal: Scalars['U64']['output'];
  bhei: Scalars['U64']['output'];
  bhsh: Scalars['U64']['output'];
  bldd?: Maybe<GqlDependentCost>;
  bsiz?: Maybe<GqlDependentCost>;
  burn: Scalars['U64']['output'];
  call: GqlDependentCost;
  cb: Scalars['U64']['output'];
  ccp: GqlDependentCost;
  cfe: GqlDependentCost;
  cfei: Scalars['U64']['output'];
  cfeiDependentCost: GqlDependentCost;
  cfsi: Scalars['U64']['output'];
  contractRoot: GqlDependentCost;
  croo: GqlDependentCost;
  csiz: GqlDependentCost;
  div: Scalars['U64']['output'];
  divi: Scalars['U64']['output'];
  eck1: Scalars['U64']['output'];
  ecop?: Maybe<Scalars['U64']['output']>;
  ecr1: Scalars['U64']['output'];
  ed19: Scalars['U64']['output'];
  ed19DependentCost: GqlDependentCost;
  epar?: Maybe<GqlDependentCost>;
  eq: Scalars['U64']['output'];
  exp: Scalars['U64']['output'];
  expi: Scalars['U64']['output'];
  flag: Scalars['U64']['output'];
  gm: Scalars['U64']['output'];
  gt: Scalars['U64']['output'];
  gtf: Scalars['U64']['output'];
  ji: Scalars['U64']['output'];
  jmp: Scalars['U64']['output'];
  jmpb: Scalars['U64']['output'];
  jmpf: Scalars['U64']['output'];
  jne: Scalars['U64']['output'];
  jneb: Scalars['U64']['output'];
  jnef: Scalars['U64']['output'];
  jnei: Scalars['U64']['output'];
  jnzb: Scalars['U64']['output'];
  jnzf: Scalars['U64']['output'];
  jnzi: Scalars['U64']['output'];
  k256: GqlDependentCost;
  lb: Scalars['U64']['output'];
  ldc: GqlDependentCost;
  log: Scalars['U64']['output'];
  logd: GqlDependentCost;
  lt: Scalars['U64']['output'];
  lw: Scalars['U64']['output'];
  mcl: GqlDependentCost;
  mcli: GqlDependentCost;
  mcp: GqlDependentCost;
  mcpi: GqlDependentCost;
  meq: GqlDependentCost;
  mint: Scalars['U64']['output'];
  mldv: Scalars['U64']['output'];
  mlog: Scalars['U64']['output'];
  modOp: Scalars['U64']['output'];
  modi: Scalars['U64']['output'];
  moveOp: Scalars['U64']['output'];
  movi: Scalars['U64']['output'];
  mroo: Scalars['U64']['output'];
  mul: Scalars['U64']['output'];
  muli: Scalars['U64']['output'];
  newStoragePerByte: Scalars['U64']['output'];
  niop?: Maybe<Scalars['U64']['output']>;
  noop: Scalars['U64']['output'];
  not: Scalars['U64']['output'];
  or: Scalars['U64']['output'];
  ori: Scalars['U64']['output'];
  poph: Scalars['U64']['output'];
  popl: Scalars['U64']['output'];
  pshh: Scalars['U64']['output'];
  pshl: Scalars['U64']['output'];
  ret: Scalars['U64']['output'];
  retd: GqlDependentCost;
  rvrt: Scalars['U64']['output'];
  s256: GqlDependentCost;
  sb: Scalars['U64']['output'];
  scwq: GqlDependentCost;
  sll: Scalars['U64']['output'];
  slli: Scalars['U64']['output'];
  smo: GqlDependentCost;
  srl: Scalars['U64']['output'];
  srli: Scalars['U64']['output'];
  srw: Scalars['U64']['output'];
  srwq: GqlDependentCost;
  stateRoot: GqlDependentCost;
  sub: Scalars['U64']['output'];
  subi: Scalars['U64']['output'];
  sw: Scalars['U64']['output'];
  sww: Scalars['U64']['output'];
  swwq: GqlDependentCost;
  time: Scalars['U64']['output'];
  tr: Scalars['U64']['output'];
  tro: Scalars['U64']['output'];
  version: GqlGasCostsVersion;
  vmInitialization: GqlDependentCost;
  wdam: Scalars['U64']['output'];
  wdcm: Scalars['U64']['output'];
  wddv: Scalars['U64']['output'];
  wdmd: Scalars['U64']['output'];
  wdml: Scalars['U64']['output'];
  wdmm: Scalars['U64']['output'];
  wdop: Scalars['U64']['output'];
  wqam: Scalars['U64']['output'];
  wqcm: Scalars['U64']['output'];
  wqdv: Scalars['U64']['output'];
  wqmd: Scalars['U64']['output'];
  wqml: Scalars['U64']['output'];
  wqmm: Scalars['U64']['output'];
  wqop: Scalars['U64']['output'];
  xor: Scalars['U64']['output'];
  xori: Scalars['U64']['output'];
};

export enum GqlGasCostsVersion {
  V1 = 'V1'
}

export type GqlGenesis = {
  /**
   * The chain configs define what consensus type to use, what settlement layer to use,
   * rules of block validity, etc.
   */
  chainConfigHash: Scalars['Bytes32']['output'];
  /** The Binary Merkle Tree root of all genesis coins. */
  coinsRoot: Scalars['Bytes32']['output'];
  /** The Binary Merkle Tree root of state, balances, contracts code hash of each contract. */
  contractsRoot: Scalars['Bytes32']['output'];
  /** The Binary Merkle Tree root of all genesis messages. */
  messagesRoot: Scalars['Bytes32']['output'];
  /** The Binary Merkle Tree root of all processed transaction ids. */
  transactionsRoot: Scalars['Bytes32']['output'];
};

export type GqlHeader = {
  /** Hash of the application header. */
  applicationHash: Scalars['Bytes32']['output'];
  /** The version of the consensus parameters used to create this block. */
  consensusParametersVersion: Scalars['U32']['output'];
  /** The layer 1 height of messages and events to include since the last layer 1 block number. */
  daHeight: Scalars['U64']['output'];
  /** Merkle root of inbox events in this block. */
  eventInboxRoot: Scalars['Bytes32']['output'];
  /** Fuel block height. */
  height: Scalars['U32']['output'];
  /** Hash of the header */
  id: Scalars['BlockId']['output'];
  /** Merkle root of message receipts in this block. */
  messageOutboxRoot: Scalars['Bytes32']['output'];
  /** Number of message receipts in this block. */
  messageReceiptCount: Scalars['U32']['output'];
  /** Merkle root of all previous block header hashes. */
  prevRoot: Scalars['Bytes32']['output'];
  /** The version of the state transition bytecode used to create this block. */
  stateTransitionBytecodeVersion: Scalars['U32']['output'];
  /** The block producer time. */
  time: Scalars['Tai64Timestamp']['output'];
  /** Number of transactions in this block. */
  transactionsCount: Scalars['U16']['output'];
  /** Merkle root of transactions. */
  transactionsRoot: Scalars['Bytes32']['output'];
  /** Transaction ID Commitment */
  txIdCommitment?: Maybe<Scalars['Bytes32']['output']>;
  /** Version of the header */
  version: GqlHeaderVersion;
};

export enum GqlHeaderVersion {
  V1 = 'V1',
  V2 = 'V2'
}

export type GqlHeavyOperation = {
  base: Scalars['U64']['output'];
  gasPerUnit: Scalars['U64']['output'];
};

export type GqlIndexationFlags = {
  /** Is asset metadata indexation enabled */
  assetMetadata: Scalars['Boolean']['output'];
  /** Is balances indexation enabled */
  balances: Scalars['Boolean']['output'];
  /** Is coins to spend indexation enabled */
  coinsToSpend: Scalars['Boolean']['output'];
};

export type GqlInput = GqlInputCoin | GqlInputContract | GqlInputMessage;

export type GqlInputCoin = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  owner: Scalars['Address']['output'];
  predicate: Scalars['HexString']['output'];
  predicateData: Scalars['HexString']['output'];
  predicateGasUsed: Scalars['U64']['output'];
  txPointer: Scalars['TxPointer']['output'];
  utxoId: Scalars['UtxoId']['output'];
  witnessIndex: Scalars['U16']['output'];
};

export type GqlInputContract = {
  balanceRoot: Scalars['Bytes32']['output'];
  contractId: Scalars['ContractId']['output'];
  stateRoot: Scalars['Bytes32']['output'];
  txPointer: Scalars['TxPointer']['output'];
  utxoId: Scalars['UtxoId']['output'];
};

export type GqlInputMessage = {
  amount: Scalars['U64']['output'];
  data: Scalars['HexString']['output'];
  nonce: Scalars['Nonce']['output'];
  predicate: Scalars['HexString']['output'];
  predicateData: Scalars['HexString']['output'];
  predicateGasUsed: Scalars['U64']['output'];
  recipient: Scalars['Address']['output'];
  sender: Scalars['Address']['output'];
  witnessIndex: Scalars['U16']['output'];
};

export type GqlLatestGasPrice = {
  blockHeight: Scalars['U32']['output'];
  gasPrice: Scalars['U64']['output'];
};

export type GqlLightOperation = {
  base: Scalars['U64']['output'];
  unitsPerGas: Scalars['U64']['output'];
};

export type GqlMerkleProof = {
  proofIndex: Scalars['U64']['output'];
  proofSet: Array<Scalars['Bytes32']['output']>;
};

export type GqlMessage = {
  amount: Scalars['U64']['output'];
  daHeight: Scalars['U64']['output'];
  data: Scalars['HexString']['output'];
  nonce: Scalars['Nonce']['output'];
  recipient: Scalars['Address']['output'];
  sender: Scalars['Address']['output'];
};

export type GqlMessageCoin = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  daHeight: Scalars['U64']['output'];
  nonce: Scalars['Nonce']['output'];
  recipient: Scalars['Address']['output'];
  sender: Scalars['Address']['output'];
};

export type GqlMessageConnection = {
  /** A list of edges. */
  edges: Array<GqlMessageEdge>;
  /** A list of nodes. */
  nodes: Array<GqlMessage>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlMessageEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GqlMessage;
};

export type GqlMessageProof = {
  amount: Scalars['U64']['output'];
  blockProof: GqlMerkleProof;
  commitBlockHeader: GqlHeader;
  data: Scalars['HexString']['output'];
  messageBlockHeader: GqlHeader;
  messageProof: GqlMerkleProof;
  nonce: Scalars['Nonce']['output'];
  recipient: Scalars['Address']['output'];
  sender: Scalars['Address']['output'];
};

export enum GqlMessageState {
  NotFound = 'NOT_FOUND',
  Spent = 'SPENT',
  Unspent = 'UNSPENT'
}

export type GqlMessageStatus = {
  state: GqlMessageState;
};

export type GqlMutation = {
  /**
   * Resume execution of the VM instance after a breakpoint.
   * Runs until the next breakpoint or until the transaction completes.
   */
  continueTx: GqlRunResult;
  /**
   * Execute a dry-run of multiple transactions using a fork of current state, no changes are committed.
   * @deprecated This doesn't need to be a mutation. Use query of the same name instead.
   */
  dryRun: Array<GqlDryRunTransactionExecutionStatus>;
  /** End debugger session. */
  endSession: Scalars['Boolean']['output'];
  /** Execute a single fuel-asm instruction. */
  execute: Scalars['Boolean']['output'];
  /**
   * Sequentially produces `blocks_to_produce` blocks. The first block starts with
   * `start_timestamp`. If the block production in the [`crate::service::Config`] is
   * `Trigger::Interval { block_time }`, produces blocks with `block_time ` intervals between
   * them. The `start_timestamp` is the timestamp in seconds.
   */
  produceBlocks: Scalars['U32']['output'];
  /** Reset the VM instance to the initial state. */
  reset: Scalars['Boolean']['output'];
  /** Set a breakpoint for a VM instance. */
  setBreakpoint: Scalars['Boolean']['output'];
  /** Set single-stepping mode for the VM instance. */
  setSingleStepping: Scalars['Boolean']['output'];
  /**
   * Initialize a new debugger session, returning its ID.
   * A new VM instance is spawned for each session.
   * The session is run in a separate database transaction,
   * on top of the most recent node state.
   */
  startSession: Scalars['ID']['output'];
  /**
   * Run a single transaction in given session until it
   * hits a breakpoint or completes.
   */
  startTx: GqlRunResult;
  /**
   * Submits transaction to the `TxPool`.
   *
   * Returns submitted transaction if the transaction is included in the `TxPool` without problems.
   */
  submit: GqlTransaction;
};


export type GqlMutationContinueTxArgs = {
  id: Scalars['ID']['input'];
};


export type GqlMutationDryRunArgs = {
  blockHeight?: InputMaybe<Scalars['U32']['input']>;
  gasPrice?: InputMaybe<Scalars['U64']['input']>;
  txs: Array<Scalars['HexString']['input']>;
  utxoValidation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlMutationEndSessionArgs = {
  id: Scalars['ID']['input'];
};


export type GqlMutationExecuteArgs = {
  id: Scalars['ID']['input'];
  op: Scalars['String']['input'];
};


export type GqlMutationProduceBlocksArgs = {
  blocksToProduce: Scalars['U32']['input'];
  startTimestamp?: InputMaybe<Scalars['Tai64Timestamp']['input']>;
};


export type GqlMutationResetArgs = {
  id: Scalars['ID']['input'];
};


export type GqlMutationSetBreakpointArgs = {
  breakpoint: GqlBreakpoint;
  id: Scalars['ID']['input'];
};


export type GqlMutationSetSingleSteppingArgs = {
  enable: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type GqlMutationStartTxArgs = {
  id: Scalars['ID']['input'];
  txJson: Scalars['String']['input'];
};


export type GqlMutationSubmitArgs = {
  estimatePredicates?: InputMaybe<Scalars['Boolean']['input']>;
  tx: Scalars['HexString']['input'];
};

export type GqlNodeInfo = {
  indexation: GqlIndexationFlags;
  maxDepth: Scalars['U64']['output'];
  maxGas: Scalars['U64']['output'];
  maxSize: Scalars['U64']['output'];
  maxTx: Scalars['U64']['output'];
  nodeVersion: Scalars['String']['output'];
  peers: Array<GqlPeerInfo>;
  txPoolStats: GqlTxPoolStats;
  utxoValidation: Scalars['Boolean']['output'];
  vmBacktrace: Scalars['Boolean']['output'];
};

export type GqlOutput = GqlChangeOutput | GqlCoinOutput | GqlContractCreated | GqlContractOutput | GqlVariableOutput;

/**
 * A separate `Breakpoint` type to be used as an output, as a single
 * type cannot act as both input and output type in async-graphql
 */
export type GqlOutputBreakpoint = {
  contract: Scalars['ContractId']['output'];
  pc: Scalars['U64']['output'];
};

/** Information about pagination in a connection */
export type GqlPageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type GqlPeerInfo = {
  /** The advertised multi-addrs that can be used to connect to this peer */
  addresses: Array<Scalars['String']['output']>;
  /** The internal fuel p2p reputation of this peer */
  appScore: Scalars['Float']['output'];
  /** The last reported height of the peer */
  blockHeight?: Maybe<Scalars['U32']['output']>;
  /** The self-reported version of the client the peer is using */
  clientVersion?: Maybe<Scalars['String']['output']>;
  /** The libp2p peer id */
  id: Scalars['String']['output'];
  /** The last heartbeat from this peer in unix epoch time ms */
  lastHeartbeatMs: Scalars['U64']['output'];
};

export type GqlPoAConsensus = {
  /** Gets the signature of the block produced by `PoA` consensus. */
  signature: Scalars['Signature']['output'];
};

export type GqlPolicies = {
  maturity?: Maybe<Scalars['U32']['output']>;
  maxFee?: Maybe<Scalars['U64']['output']>;
  tip?: Maybe<Scalars['U64']['output']>;
  witnessLimit?: Maybe<Scalars['U64']['output']>;
};

export type GqlPreconfirmationFailureStatus = {
  reason: Scalars['String']['output'];
  receipts?: Maybe<Array<GqlReceipt>>;
  resolvedOutputs?: Maybe<Array<GqlResolvedOutput>>;
  totalFee: Scalars['U64']['output'];
  totalGas: Scalars['U64']['output'];
  transaction?: Maybe<GqlTransaction>;
  transactionId: Scalars['TransactionId']['output'];
  txPointer: Scalars['TxPointer']['output'];
};

export type GqlPreconfirmationSuccessStatus = {
  receipts?: Maybe<Array<GqlReceipt>>;
  resolvedOutputs?: Maybe<Array<GqlResolvedOutput>>;
  totalFee: Scalars['U64']['output'];
  totalGas: Scalars['U64']['output'];
  transaction?: Maybe<GqlTransaction>;
  transactionId: Scalars['TransactionId']['output'];
  txPointer: Scalars['TxPointer']['output'];
};

export type GqlPredicate = {
  predicate: Scalars['HexString']['input'];
  predicateAddress: Scalars['Address']['input'];
  predicateData: Scalars['HexString']['input'];
};

export type GqlPredicateParameters = {
  maxGasPerPredicate: Scalars['U64']['output'];
  maxMessageDataLength: Scalars['U64']['output'];
  maxPredicateDataLength: Scalars['U64']['output'];
  maxPredicateLength: Scalars['U64']['output'];
  version: GqlPredicateParametersVersion;
};

export enum GqlPredicateParametersVersion {
  V1 = 'V1'
}

export type GqlProgramState = {
  data: Scalars['HexString']['output'];
  returnType: GqlReturnType;
};

export type GqlQuery = {
  /**
   * Assembles the transaction based on the provided requirements.
   * The return transaction contains:
   * - Input coins to cover `required_balances`
   * - Input coins to cover the fee of the transaction based on the gas price from `block_horizon`
   * - `Change` or `Destroy` outputs for all assets from the inputs
   * - `Variable` outputs in the case they are required during the execution
   * - `Contract` inputs and outputs in the case they are required during the execution
   * - Reserved witness slots for signed coins filled with `64` zeroes
   * - Set script gas limit(unless `script` is empty)
   * - Estimated predicates, if `estimate_predicates == true`
   *
   * Returns an error if:
   * - The number of required balances exceeds the maximum number of inputs allowed.
   * - The fee address index is out of bounds.
   * - The same asset has multiple change policies(either the receiver of
   * the change is different, or one of the policies states about the destruction
   * of the token while the other does not). The `Change` output from the transaction
   * also count as a `ChangePolicy`.
   * - The number of excluded coin IDs exceeds the maximum number of inputs allowed.
   * - Required assets have multiple entries.
   * - If accounts don't have sufficient amounts to cover the transaction requirements in assets.
   * - If a constructed transaction breaks the rules defined by consensus parameters.
   */
  assembleTx: GqlAssembleTransactionResult;
  assetDetails?: Maybe<GqlAssetInfoDetails>;
  balance: GqlBalance;
  balances: GqlBalanceConnection;
  blob?: Maybe<GqlBlob>;
  block?: Maybe<GqlBlock>;
  blocks: GqlBlockConnection;
  chain: GqlChainInfo;
  /** Gets the coin by `utxo_id`. */
  coin?: Maybe<GqlCoin>;
  /** Gets all unspent coins of some `owner` maybe filtered with by `asset_id` per page. */
  coins: GqlCoinConnection;
  /**
   * For each `query_per_asset`, get some spendable coins(of asset specified by the query) owned by
   * `owner` that add up at least the query amount. The returned coins can be spent.
   * The number of coins is optimized to prevent dust accumulation.
   *
   * The query supports excluding and maximum the number of coins.
   *
   * Returns:
   * The list of spendable coins per asset from the query. The length of the result is
   * the same as the length of `query_per_asset`. The ordering of assets and `query_per_asset`
   * is the same.
   */
  coinsToSpend: Array<Array<GqlCoinType>>;
  consensusParameters: GqlConsensusParameters;
  contract?: Maybe<GqlContract>;
  contractBalance: GqlContractBalance;
  /**
   * Get balance values for a contract at a specific block height.
   * Use the latest block height if not provided.
   * Requires historical execution config to be enabled.
   */
  contractBalanceValues: Array<GqlContractBalance>;
  contractBalances: GqlContractBalanceConnection;
  /**
   * Get storage slot values for a contract at a specific block height.
   * Use the latest block height if not provided.
   * Requires historical execution config to be enabled.
   */
  contractSlotValues: Array<GqlStorageSlot>;
  daCompressedBlock?: Maybe<GqlDaCompressedBlock>;
  /** Execute a dry-run of multiple transactions using a fork of current state, no changes are committed. */
  dryRun: Array<GqlDryRunTransactionExecutionStatus>;
  /**
   * Execute a dry-run of multiple transactions using a fork of current state, no changes are committed.
   * Also records accesses, so the execution can be replicated locally.
   */
  dryRunRecordStorageReads: GqlDryRunStorageReads;
  estimateGasPrice: GqlEstimateGasPrice;
  /** Estimate the predicate gas for the provided transaction */
  estimatePredicates: GqlTransaction;
  /** Returns true when the GraphQL API is serving requests. */
  health: Scalars['Boolean']['output'];
  latestGasPrice: GqlLatestGasPrice;
  /** Read read a range of memory bytes. */
  memory: Scalars['String']['output'];
  message?: Maybe<GqlMessage>;
  messageProof: GqlMessageProof;
  messageStatus: GqlMessageStatus;
  messages: GqlMessageConnection;
  nodeInfo: GqlNodeInfo;
  /** Read register value by index. */
  register: Scalars['U64']['output'];
  relayedTransactionStatus?: Maybe<GqlRelayedTransactionStatus>;
  stateTransitionBytecodeByRoot: GqlStateTransitionBytecode;
  stateTransitionBytecodeByVersion?: Maybe<GqlStateTransitionBytecode>;
  /** Get execution trace for an already-executed block. */
  storageReadReplay: Array<GqlStorageReadReplayEvent>;
  transaction?: Maybe<GqlTransaction>;
  transactions: GqlTransactionConnection;
  transactionsByOwner: GqlTransactionConnection;
};


export type GqlQueryAssembleTxArgs = {
  blockHorizon: Scalars['U32']['input'];
  estimatePredicates?: InputMaybe<Scalars['Boolean']['input']>;
  excludeInput?: InputMaybe<GqlExcludeInput>;
  feeAddressIndex: Scalars['U16']['input'];
  requiredBalances: Array<GqlRequiredBalance>;
  reserveGas?: InputMaybe<Scalars['U64']['input']>;
  tx: Scalars['HexString']['input'];
};


export type GqlQueryAssetDetailsArgs = {
  id: Scalars['AssetId']['input'];
};


export type GqlQueryBalanceArgs = {
  assetId: Scalars['AssetId']['input'];
  owner: Scalars['Address']['input'];
};


export type GqlQueryBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: GqlBalanceFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryBlobArgs = {
  id: Scalars['BlobId']['input'];
};


export type GqlQueryBlockArgs = {
  height?: InputMaybe<Scalars['U32']['input']>;
  id?: InputMaybe<Scalars['BlockId']['input']>;
};


export type GqlQueryBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryCoinArgs = {
  utxoId: Scalars['UtxoId']['input'];
};


export type GqlQueryCoinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: GqlCoinFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryCoinsToSpendArgs = {
  excludedIds?: InputMaybe<GqlExcludeInput>;
  owner: Scalars['Address']['input'];
  queryPerAsset: Array<GqlSpendQueryElementInput>;
};


export type GqlQueryConsensusParametersArgs = {
  version: Scalars['Int']['input'];
};


export type GqlQueryContractArgs = {
  id: Scalars['ContractId']['input'];
};


export type GqlQueryContractBalanceArgs = {
  asset: Scalars['AssetId']['input'];
  contract: Scalars['ContractId']['input'];
};


export type GqlQueryContractBalanceValuesArgs = {
  assets: Array<Scalars['AssetId']['input']>;
  blockHeight?: InputMaybe<Scalars['U32']['input']>;
  contractId: Scalars['ContractId']['input'];
};


export type GqlQueryContractBalancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter: GqlContractBalanceFilterInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryContractSlotValuesArgs = {
  blockHeight?: InputMaybe<Scalars['U32']['input']>;
  contractId: Scalars['ContractId']['input'];
  storageSlots: Array<Scalars['Bytes32']['input']>;
};


export type GqlQueryDaCompressedBlockArgs = {
  height: Scalars['U32']['input'];
};


export type GqlQueryDryRunArgs = {
  blockHeight?: InputMaybe<Scalars['U32']['input']>;
  gasPrice?: InputMaybe<Scalars['U64']['input']>;
  txs: Array<Scalars['HexString']['input']>;
  utxoValidation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryDryRunRecordStorageReadsArgs = {
  blockHeight?: InputMaybe<Scalars['U32']['input']>;
  gasPrice?: InputMaybe<Scalars['U64']['input']>;
  txs: Array<Scalars['HexString']['input']>;
  utxoValidation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlQueryEstimateGasPriceArgs = {
  blockHorizon?: InputMaybe<Scalars['U32']['input']>;
};


export type GqlQueryEstimatePredicatesArgs = {
  tx: Scalars['HexString']['input'];
};


export type GqlQueryMemoryArgs = {
  id: Scalars['ID']['input'];
  size: Scalars['U32']['input'];
  start: Scalars['U32']['input'];
};


export type GqlQueryMessageArgs = {
  nonce: Scalars['Nonce']['input'];
};


export type GqlQueryMessageProofArgs = {
  commitBlockHeight?: InputMaybe<Scalars['U32']['input']>;
  commitBlockId?: InputMaybe<Scalars['BlockId']['input']>;
  nonce: Scalars['Nonce']['input'];
  transactionId: Scalars['TransactionId']['input'];
};


export type GqlQueryMessageStatusArgs = {
  nonce: Scalars['Nonce']['input'];
};


export type GqlQueryMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owner?: InputMaybe<Scalars['Address']['input']>;
};


export type GqlQueryRegisterArgs = {
  id: Scalars['ID']['input'];
  register: Scalars['U32']['input'];
};


export type GqlQueryRelayedTransactionStatusArgs = {
  id: Scalars['RelayedTransactionId']['input'];
};


export type GqlQueryStateTransitionBytecodeByRootArgs = {
  root: Scalars['HexString']['input'];
};


export type GqlQueryStateTransitionBytecodeByVersionArgs = {
  version: Scalars['Int']['input'];
};


export type GqlQueryStorageReadReplayArgs = {
  height: Scalars['U32']['input'];
};


export type GqlQueryTransactionArgs = {
  id: Scalars['TransactionId']['input'];
};


export type GqlQueryTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GqlQueryTransactionsByOwnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  owner: Scalars['Address']['input'];
};

export type GqlReceipt = {
  amount?: Maybe<Scalars['U64']['output']>;
  assetId?: Maybe<Scalars['AssetId']['output']>;
  /** Set in the case of a Panic receipt to indicate a missing contract input id */
  contractId?: Maybe<Scalars['ContractId']['output']>;
  data?: Maybe<Scalars['HexString']['output']>;
  digest?: Maybe<Scalars['Bytes32']['output']>;
  gas?: Maybe<Scalars['U64']['output']>;
  gasUsed?: Maybe<Scalars['U64']['output']>;
  id?: Maybe<Scalars['ContractId']['output']>;
  is?: Maybe<Scalars['U64']['output']>;
  len?: Maybe<Scalars['U64']['output']>;
  nonce?: Maybe<Scalars['Nonce']['output']>;
  param1?: Maybe<Scalars['U64']['output']>;
  param2?: Maybe<Scalars['U64']['output']>;
  pc?: Maybe<Scalars['U64']['output']>;
  ptr?: Maybe<Scalars['U64']['output']>;
  ra?: Maybe<Scalars['U64']['output']>;
  rb?: Maybe<Scalars['U64']['output']>;
  rc?: Maybe<Scalars['U64']['output']>;
  rd?: Maybe<Scalars['U64']['output']>;
  reason?: Maybe<Scalars['U64']['output']>;
  receiptType: GqlReceiptType;
  recipient?: Maybe<Scalars['Address']['output']>;
  result?: Maybe<Scalars['U64']['output']>;
  sender?: Maybe<Scalars['Address']['output']>;
  subId?: Maybe<Scalars['SubId']['output']>;
  to?: Maybe<Scalars['ContractId']['output']>;
  toAddress?: Maybe<Scalars['Address']['output']>;
  val?: Maybe<Scalars['U64']['output']>;
};

export enum GqlReceiptType {
  Burn = 'BURN',
  Call = 'CALL',
  Log = 'LOG',
  LogData = 'LOG_DATA',
  MessageOut = 'MESSAGE_OUT',
  Mint = 'MINT',
  Panic = 'PANIC',
  Return = 'RETURN',
  ReturnData = 'RETURN_DATA',
  Revert = 'REVERT',
  ScriptResult = 'SCRIPT_RESULT',
  Transfer = 'TRANSFER',
  TransferOut = 'TRANSFER_OUT'
}

export type GqlRelayedTransactionFailed = {
  blockHeight: Scalars['U32']['output'];
  failure: Scalars['String']['output'];
};

export type GqlRelayedTransactionStatus = GqlRelayedTransactionFailed;

export type GqlRequiredBalance = {
  account: GqlAccount;
  amount: Scalars['U64']['input'];
  assetId: Scalars['AssetId']['input'];
  changePolicy: GqlChangePolicy;
};

export type GqlResolvedOutput = {
  output: GqlOutput;
  utxoId: Scalars['UtxoId']['output'];
};

export enum GqlReturnType {
  Return = 'RETURN',
  ReturnData = 'RETURN_DATA',
  Revert = 'REVERT'
}

export type GqlRunResult = {
  breakpoint?: Maybe<GqlOutputBreakpoint>;
  jsonReceipts: Array<Scalars['String']['output']>;
  state: GqlRunState;
};

export enum GqlRunState {
  /** Stopped on a breakpoint */
  Breakpoint = 'BREAKPOINT',
  /** All breakpoints have been processed, and the program has terminated */
  Completed = 'COMPLETED'
}

export type GqlScriptParameters = {
  maxScriptDataLength: Scalars['U64']['output'];
  maxScriptLength: Scalars['U64']['output'];
  version: GqlScriptParametersVersion;
};

export enum GqlScriptParametersVersion {
  V1 = 'V1'
}

export type GqlSpendQueryElementInput = {
  /** If true, returns available coins instead of failing when the requested amount is unavailable. */
  allowPartial?: InputMaybe<Scalars['Boolean']['input']>;
  /** Target amount for the query. */
  amount: Scalars['U128']['input'];
  /** Identifier of the asset to spend. */
  assetId: Scalars['AssetId']['input'];
  /** The maximum number of currencies for selection. */
  max?: InputMaybe<Scalars['U16']['input']>;
};

export type GqlSqueezedOutStatus = {
  reason: Scalars['String']['output'];
  transactionId: Scalars['TransactionId']['output'];
};

export type GqlStateTransitionBytecode = {
  bytecode: GqlUploadedBytecode;
  root: Scalars['HexString']['output'];
};

export type GqlStateTransitionPurpose = {
  root: Scalars['Bytes32']['output'];
};

export type GqlStorageReadReplayEvent = {
  column: Scalars['U32']['output'];
  key: Scalars['HexString']['output'];
  value?: Maybe<Scalars['HexString']['output']>;
};

export type GqlStorageSlot = {
  key: Scalars['Bytes32']['output'];
  value: Scalars['HexString']['output'];
};

export type GqlSubmittedStatus = {
  time: Scalars['Tai64Timestamp']['output'];
};

export type GqlSubscription = {
  alpha__new_blocks: Scalars['HexString']['output'];
  alpha__preconfirmations: GqlTransactionStatus;
  contractStorageBalances: GqlContractBalance;
  contractStorageSlots: GqlStorageSlot;
  /**
   * Returns a stream of status updates for the given transaction id.
   * If the current status is [`TransactionStatus::Success`], [`TransactionStatus::Failed`],
   * or [`TransactionStatus::SqueezedOut`] the stream will return that and end immediately.
   * Other, intermediate statuses will also be returned but the stream will remain active
   * and wait for a future updates.
   *
   * This stream will wait forever so it's advised to use within a timeout.
   *
   * It is possible for the stream to miss an update if it is polled slower
   * then the updates arrive. In such a case the stream will close without
   * a status. If this occurs the stream can simply be restarted to return
   * the latest status.
   */
  statusChange: GqlTransactionStatus;
  /** Submits transaction to the `TxPool` and await either success or failure. */
  submitAndAwait: GqlTransactionStatus;
  /**
   * Submits the transaction to the `TxPool` and returns a stream of events.
   * Compared to the `submitAndAwait`, the stream also contains
   * `SubmittedStatus` and potentially preconfirmation as an intermediate state.
   */
  submitAndAwaitStatus: GqlTransactionStatus;
};


export type GqlSubscriptionContractStorageBalancesArgs = {
  contractId: Scalars['ContractId']['input'];
};


export type GqlSubscriptionContractStorageSlotsArgs = {
  contractId: Scalars['ContractId']['input'];
};


export type GqlSubscriptionStatusChangeArgs = {
  id: Scalars['TransactionId']['input'];
  includePreconfirmation?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GqlSubscriptionSubmitAndAwaitArgs = {
  estimatePredicates?: InputMaybe<Scalars['Boolean']['input']>;
  tx: Scalars['HexString']['input'];
};


export type GqlSubscriptionSubmitAndAwaitStatusArgs = {
  estimatePredicates?: InputMaybe<Scalars['Boolean']['input']>;
  includePreconfirmation?: InputMaybe<Scalars['Boolean']['input']>;
  tx: Scalars['HexString']['input'];
};

export type GqlSuccessStatus = {
  block: GqlBlock;
  blockHeight: Scalars['U32']['output'];
  programState?: Maybe<GqlProgramState>;
  receipts: Array<GqlReceipt>;
  time: Scalars['Tai64Timestamp']['output'];
  totalFee: Scalars['U64']['output'];
  totalGas: Scalars['U64']['output'];
  transaction: GqlTransaction;
  transactionId: Scalars['TransactionId']['output'];
};

export type GqlTransaction = {
  blobId?: Maybe<Scalars['BlobId']['output']>;
  bytecodeRoot?: Maybe<Scalars['Bytes32']['output']>;
  bytecodeWitnessIndex?: Maybe<Scalars['U16']['output']>;
  id: Scalars['TransactionId']['output'];
  inputAssetIds?: Maybe<Array<Scalars['AssetId']['output']>>;
  inputContract?: Maybe<GqlInputContract>;
  inputContracts?: Maybe<Array<Scalars['ContractId']['output']>>;
  inputs?: Maybe<Array<GqlInput>>;
  isBlob: Scalars['Boolean']['output'];
  isCreate: Scalars['Boolean']['output'];
  isMint: Scalars['Boolean']['output'];
  isScript: Scalars['Boolean']['output'];
  isUpgrade: Scalars['Boolean']['output'];
  isUpload: Scalars['Boolean']['output'];
  maturity?: Maybe<Scalars['U32']['output']>;
  mintAmount?: Maybe<Scalars['U64']['output']>;
  mintAssetId?: Maybe<Scalars['AssetId']['output']>;
  mintGasPrice?: Maybe<Scalars['U64']['output']>;
  outputContract?: Maybe<GqlContractOutput>;
  outputs: Array<GqlOutput>;
  policies?: Maybe<GqlPolicies>;
  proofSet?: Maybe<Array<Scalars['Bytes32']['output']>>;
  /** Return the transaction bytes using canonical encoding */
  rawPayload: Scalars['HexString']['output'];
  receiptsRoot?: Maybe<Scalars['Bytes32']['output']>;
  salt?: Maybe<Scalars['Salt']['output']>;
  script?: Maybe<Scalars['HexString']['output']>;
  scriptData?: Maybe<Scalars['HexString']['output']>;
  scriptGasLimit?: Maybe<Scalars['U64']['output']>;
  status?: Maybe<GqlTransactionStatus>;
  storageSlots?: Maybe<Array<Scalars['HexString']['output']>>;
  subsectionIndex?: Maybe<Scalars['U16']['output']>;
  subsectionsNumber?: Maybe<Scalars['U16']['output']>;
  txPointer?: Maybe<Scalars['TxPointer']['output']>;
  upgradePurpose?: Maybe<GqlUpgradePurpose>;
  witnesses?: Maybe<Array<Scalars['HexString']['output']>>;
};


export type GqlTransactionStatusArgs = {
  includePreconfirmation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GqlTransactionConnection = {
  /** A list of edges. */
  edges: Array<GqlTransactionEdge>;
  /** A list of nodes. */
  nodes: Array<GqlTransaction>;
  /** Information to aid in pagination. */
  pageInfo: GqlPageInfo;
};

/** An edge in a connection. */
export type GqlTransactionEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GqlTransaction;
};

export type GqlTransactionStatus = GqlFailureStatus | GqlPreconfirmationFailureStatus | GqlPreconfirmationSuccessStatus | GqlSqueezedOutStatus | GqlSubmittedStatus | GqlSuccessStatus;

export type GqlTxParameters = {
  maxBytecodeSubsections: Scalars['U16']['output'];
  maxGasPerTx: Scalars['U64']['output'];
  maxInputs: Scalars['U16']['output'];
  maxOutputs: Scalars['U16']['output'];
  maxSize: Scalars['U64']['output'];
  maxWitnesses: Scalars['U32']['output'];
  version: GqlTxParametersVersion;
};

export enum GqlTxParametersVersion {
  V1 = 'V1'
}

export type GqlTxPoolStats = {
  /** The total gas of the transactions in the pool */
  totalGas: Scalars['U64']['output'];
  /** The total size of the transactions in the pool */
  totalSize: Scalars['U64']['output'];
  /** The number of transactions in the pool */
  txCount: Scalars['U64']['output'];
};

export type GqlUpgradePurpose = GqlConsensusParametersPurpose | GqlStateTransitionPurpose;

export type GqlUploadedBytecode = {
  /** Combined bytecode of all uploaded subsections. */
  bytecode: Scalars['HexString']['output'];
  /** Indicates if the bytecode upload is complete. */
  completed: Scalars['Boolean']['output'];
  /** Number of uploaded subsections (if incomplete). */
  uploadedSubsectionsNumber?: Maybe<Scalars['Int']['output']>;
};

export type GqlVariableOutput = {
  amount: Scalars['U64']['output'];
  assetId: Scalars['AssetId']['output'];
  to: Scalars['Address']['output'];
};

export type GqlInputCoinFragment = { utxoId: string, owner: string, amount: string, assetId: string, txPointer: string, predicateGasUsed: string, predicate: string, predicateData: string, type: 'InputCoin', coinWitnessIndex: string };

export type GqlInputMessageFragment = { sender: string, recipient: string, amount: string, nonce: string, predicateGasUsed: string, data: string, predicate: string, predicateData: string, type: 'InputMessage', messageWitnessIndex: string };

export type GqlInputContractFragment = { utxoId: string, balanceRoot: string, stateRoot: string, txPointer: string, contractId: string, type: 'InputContract' };

export type GqlOutputCoinFragment = { to: string, amount: string, assetId: string, type: 'CoinOutput' };

export type GqlOutputContractFragment = { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' };

export type GqlOutputChangeFragment = { to: string, amount: string, assetId: string, type: 'ChangeOutput' };

export type GqlOutputVariableFragment = { to: string, amount: string, assetId: string, type: 'VariableOutput' };

export type GqlOutputContractCreatedFragment = { contract: string, stateRoot: string, type: 'ContractCreated' };

export type GqlSubmittedStatusFragment = { time: string, type: 'SubmittedStatus' };

export type GqlSuccessStatusFragment = { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlSuccessStatusWithBlockIdFragment = { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', block: { id: string }, programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlFailureStatusFragment = { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlFailureStatusWithBlockIdFragment = { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', block: { id: string }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlSqueezedOutStatusFragment = { reason: string, type: 'SqueezedOutStatus' };

export type GqlPreconfirmationSuccessStatusFragment = { totalGas: string, totalFee: string, type: 'PreconfirmationSuccessStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null };

export type GqlPreconfirmationFailureStatusFragment = { reason: string, totalGas: string, totalFee: string, type: 'PreconfirmationFailureStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null };

type GqlTransactionStatusFragment_FailureStatus = { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

type GqlTransactionStatusFragment_PreconfirmationFailureStatus = {};

type GqlTransactionStatusFragment_PreconfirmationSuccessStatus = {};

type GqlTransactionStatusFragment_SqueezedOutStatus = { reason: string, type: 'SqueezedOutStatus' };

type GqlTransactionStatusFragment_SubmittedStatus = { time: string, type: 'SubmittedStatus' };

type GqlTransactionStatusFragment_SuccessStatus = { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlTransactionStatusFragment = GqlTransactionStatusFragment_FailureStatus | GqlTransactionStatusFragment_PreconfirmationFailureStatus | GqlTransactionStatusFragment_PreconfirmationSuccessStatus | GqlTransactionStatusFragment_SqueezedOutStatus | GqlTransactionStatusFragment_SubmittedStatus | GqlTransactionStatusFragment_SuccessStatus;

export type GqlMalleableTransactionFieldsFragment = { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> };

type GqlTransactionStatusSubscriptionFragment_FailureStatus = { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', transaction: { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> }, block: { id: string }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

type GqlTransactionStatusSubscriptionFragment_PreconfirmationFailureStatus = { reason: string, totalGas: string, totalFee: string, type: 'PreconfirmationFailureStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null };

type GqlTransactionStatusSubscriptionFragment_PreconfirmationSuccessStatus = { totalGas: string, totalFee: string, type: 'PreconfirmationSuccessStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null };

type GqlTransactionStatusSubscriptionFragment_SqueezedOutStatus = { reason: string, type: 'SqueezedOutStatus' };

type GqlTransactionStatusSubscriptionFragment_SubmittedStatus = { time: string, type: 'SubmittedStatus' };

type GqlTransactionStatusSubscriptionFragment_SuccessStatus = { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', transaction: { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> }, block: { id: string }, programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlTransactionStatusSubscriptionFragment = GqlTransactionStatusSubscriptionFragment_FailureStatus | GqlTransactionStatusSubscriptionFragment_PreconfirmationFailureStatus | GqlTransactionStatusSubscriptionFragment_PreconfirmationSuccessStatus | GqlTransactionStatusSubscriptionFragment_SqueezedOutStatus | GqlTransactionStatusSubscriptionFragment_SubmittedStatus | GqlTransactionStatusSubscriptionFragment_SuccessStatus;

export type GqlTransactionFragment = { id: string, rawPayload: string, status?: { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { reason: string, type: 'SqueezedOutStatus' } | { time: string, type: 'SubmittedStatus' } | { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | {} | null };

export type GqlTransactionRawPayloadFragment = { id: string, rawPayload: string };

type GqlInputEstimatePredicatesFragment_InputCoin = { predicateGasUsed: string };

type GqlInputEstimatePredicatesFragment_InputContract = {};

type GqlInputEstimatePredicatesFragment_InputMessage = { predicateGasUsed: string };

export type GqlInputEstimatePredicatesFragment = GqlInputEstimatePredicatesFragment_InputCoin | GqlInputEstimatePredicatesFragment_InputContract | GqlInputEstimatePredicatesFragment_InputMessage;

export type GqlTransactionEstimatePredicatesFragment = { inputs?: Array<{ predicateGasUsed: string } | { predicateGasUsed: string } | {}> | null };

export type GqlDryRunFailureStatusFragment = { totalGas: string, totalFee: string, reason: string, type: 'DryRunFailureStatus', programState?: { returnType: GqlReturnType, data: string } | null };

export type GqlDryRunSuccessStatusFragment = { totalGas: string, totalFee: string, type: 'DryRunSuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null };

export type GqlDryRunFailureAssembleTxFragment = { reason: string, type: 'DryRunFailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlDryRunSuccessAssembleTxFragment = { type: 'DryRunSuccessStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlReceiptFragment = { id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null };

type GqlDryRunTransactionStatusFragment_DryRunFailureStatus = { totalGas: string, totalFee: string, reason: string, type: 'DryRunFailureStatus', programState?: { returnType: GqlReturnType, data: string } | null };

type GqlDryRunTransactionStatusFragment_DryRunSuccessStatus = { totalGas: string, totalFee: string, type: 'DryRunSuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null };

export type GqlDryRunTransactionStatusFragment = GqlDryRunTransactionStatusFragment_DryRunFailureStatus | GqlDryRunTransactionStatusFragment_DryRunSuccessStatus;

export type GqlDryRunTransactionExecutionStatusFragment = { id: string, status: { totalGas: string, totalFee: string, reason: string, type: 'DryRunFailureStatus', programState?: { returnType: GqlReturnType, data: string } | null } | { totalGas: string, totalFee: string, type: 'DryRunSuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> };

export type GqlBlockFragment = { id: string, height: string, header: { time: string, daHeight: string, stateTransitionBytecodeVersion: string, transactionsCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, prevRoot: string, applicationHash: string }, transactions: Array<{ id: string }> };

export type GqlCoinFragment = { utxoId: string, amount: string, assetId: string, blockCreated: string, txCreatedIdx: string, type: 'Coin' };

export type GqlMessageCoinFragment = { sender: string, recipient: string, nonce: string, amount: string, assetId: string, daHeight: string, type: 'MessageCoin' };

export type GqlMessageFragment = { amount: string, sender: string, recipient: string, data: string, daHeight: string };

export type GqlGetMessageFragment = { nonce: string, amount: string, sender: string, recipient: string, data: string, daHeight: string };

export type GqlMessageProofFragment = { sender: string, recipient: string, amount: string, data: string, messageProof: { proofSet: Array<string>, proofIndex: string }, blockProof: { proofSet: Array<string>, proofIndex: string }, messageBlockHeader: { version: GqlHeaderVersion, id: string, daHeight: string, consensusParametersVersion: string, stateTransitionBytecodeVersion: string, transactionsCount: string, messageReceiptCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, height: string, prevRoot: string, time: string, applicationHash: string }, commitBlockHeader: { version: GqlHeaderVersion, id: string, daHeight: string, consensusParametersVersion: string, stateTransitionBytecodeVersion: string, transactionsCount: string, messageReceiptCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, height: string, prevRoot: string, time: string, applicationHash: string } };

export type GqlTxParametersFragment = { version: GqlTxParametersVersion, maxInputs: string, maxOutputs: string, maxWitnesses: string, maxGasPerTx: string, maxSize: string, maxBytecodeSubsections: string };

export type GqlPredicateParametersFragment = { version: GqlPredicateParametersVersion, maxPredicateLength: string, maxPredicateDataLength: string, maxGasPerPredicate: string, maxMessageDataLength: string };

export type GqlScriptParametersFragment = { version: GqlScriptParametersVersion, maxScriptLength: string, maxScriptDataLength: string };

export type GqlContractParametersFragment = { version: GqlContractParametersVersion, contractMaxSize: string, maxStorageSlots: string };

export type GqlFeeParametersFragment = { version: GqlFeeParametersVersion, gasPriceFactor: string, gasPerByte: string };

type GqlDependentCostFragment_HeavyOperation = { base: string, gasPerUnit: string, type: 'HeavyOperation' };

type GqlDependentCostFragment_LightOperation = { base: string, unitsPerGas: string, type: 'LightOperation' };

export type GqlDependentCostFragment = GqlDependentCostFragment_HeavyOperation | GqlDependentCostFragment_LightOperation;

export type GqlGasCostsFragment = { ecr1: string, newStoragePerByte: string, contractRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, stateRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, vmInitialization: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, s256: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' } };

export type GqlConsensusParametersFragment = { version: GqlConsensusParametersVersion, baseAssetId: string, chainId: string, txParams: { version: GqlTxParametersVersion, maxInputs: string, maxOutputs: string, maxWitnesses: string, maxGasPerTx: string, maxSize: string, maxBytecodeSubsections: string }, predicateParams: { version: GqlPredicateParametersVersion, maxPredicateLength: string, maxPredicateDataLength: string, maxGasPerPredicate: string, maxMessageDataLength: string }, scriptParams: { version: GqlScriptParametersVersion, maxScriptLength: string, maxScriptDataLength: string }, contractParams: { version: GqlContractParametersVersion, contractMaxSize: string, maxStorageSlots: string }, feeParams: { version: GqlFeeParametersVersion, gasPriceFactor: string, gasPerByte: string }, gasCosts: { ecr1: string, newStoragePerByte: string, contractRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, stateRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, vmInitialization: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, s256: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' } } };

export type GqlChainInfoFragment = { name: string, daHeight: string, consensusParameters: { version: GqlConsensusParametersVersion, baseAssetId: string, chainId: string, txParams: { version: GqlTxParametersVersion, maxInputs: string, maxOutputs: string, maxWitnesses: string, maxGasPerTx: string, maxSize: string, maxBytecodeSubsections: string }, predicateParams: { version: GqlPredicateParametersVersion, maxPredicateLength: string, maxPredicateDataLength: string, maxGasPerPredicate: string, maxMessageDataLength: string }, scriptParams: { version: GqlScriptParametersVersion, maxScriptLength: string, maxScriptDataLength: string }, contractParams: { version: GqlContractParametersVersion, contractMaxSize: string, maxStorageSlots: string }, feeParams: { version: GqlFeeParametersVersion, gasPriceFactor: string, gasPerByte: string }, gasCosts: { ecr1: string, newStoragePerByte: string, contractRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, stateRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, vmInitialization: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, s256: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' } } }, latestBlock: { header: { consensusParametersVersion: string } } };

export type GqlContractBalanceFragment = { contract: string, amount: string, assetId: string };

export type GqlPageInfoFragment = { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type GqlGetVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetVersionQuery = { nodeInfo: { nodeVersion: string } };

export type GqlNodeInfoFragment = { utxoValidation: boolean, vmBacktrace: boolean, maxTx: string, maxDepth: string, nodeVersion: string, indexation: { balances: boolean, coinsToSpend: boolean, assetMetadata: boolean } };

export type GqlRelayedTransactionStatusFragment = { blockHeight: string, failure: string };

export type GqlGetNodeInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetNodeInfoQuery = { nodeInfo: { utxoValidation: boolean, vmBacktrace: boolean, maxTx: string, maxDepth: string, nodeVersion: string, indexation: { balances: boolean, coinsToSpend: boolean, assetMetadata: boolean } } };

export type GqlGetChainQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetChainQuery = { chain: { name: string, daHeight: string, consensusParameters: { version: GqlConsensusParametersVersion, baseAssetId: string, chainId: string, txParams: { version: GqlTxParametersVersion, maxInputs: string, maxOutputs: string, maxWitnesses: string, maxGasPerTx: string, maxSize: string, maxBytecodeSubsections: string }, predicateParams: { version: GqlPredicateParametersVersion, maxPredicateLength: string, maxPredicateDataLength: string, maxGasPerPredicate: string, maxMessageDataLength: string }, scriptParams: { version: GqlScriptParametersVersion, maxScriptLength: string, maxScriptDataLength: string }, contractParams: { version: GqlContractParametersVersion, contractMaxSize: string, maxStorageSlots: string }, feeParams: { version: GqlFeeParametersVersion, gasPriceFactor: string, gasPerByte: string }, gasCosts: { ecr1: string, newStoragePerByte: string, contractRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, stateRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, vmInitialization: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, s256: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' } } }, latestBlock: { header: { consensusParametersVersion: string } } } };

export type GqlGetChainAndNodeInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetChainAndNodeInfoQuery = { chain: { name: string, daHeight: string, consensusParameters: { version: GqlConsensusParametersVersion, baseAssetId: string, chainId: string, txParams: { version: GqlTxParametersVersion, maxInputs: string, maxOutputs: string, maxWitnesses: string, maxGasPerTx: string, maxSize: string, maxBytecodeSubsections: string }, predicateParams: { version: GqlPredicateParametersVersion, maxPredicateLength: string, maxPredicateDataLength: string, maxGasPerPredicate: string, maxMessageDataLength: string }, scriptParams: { version: GqlScriptParametersVersion, maxScriptLength: string, maxScriptDataLength: string }, contractParams: { version: GqlContractParametersVersion, contractMaxSize: string, maxStorageSlots: string }, feeParams: { version: GqlFeeParametersVersion, gasPriceFactor: string, gasPerByte: string }, gasCosts: { ecr1: string, newStoragePerByte: string, contractRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, stateRoot: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, vmInitialization: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' }, s256: { base: string, gasPerUnit: string, type: 'HeavyOperation' } | { base: string, unitsPerGas: string, type: 'LightOperation' } } }, latestBlock: { header: { consensusParametersVersion: string } } }, nodeInfo: { utxoValidation: boolean, vmBacktrace: boolean, maxTx: string, maxDepth: string, nodeVersion: string, indexation: { balances: boolean, coinsToSpend: boolean, assetMetadata: boolean } } };

export type GqlGetTransactionQueryVariables = Exact<{
  transactionId: Scalars['TransactionId']['input'];
}>;


export type GqlGetTransactionQuery = { transaction?: { id: string, rawPayload: string, status?: { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { reason: string, type: 'SqueezedOutStatus' } | { time: string, type: 'SubmittedStatus' } | { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | {} | null } | null };

export type GqlGetTransactionWithReceiptsQueryVariables = Exact<{
  transactionId: Scalars['TransactionId']['input'];
}>;


export type GqlGetTransactionWithReceiptsQuery = { transaction?: { id: string, rawPayload: string, status?: { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', block: { id: string }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { reason: string, totalGas: string, totalFee: string, type: 'PreconfirmationFailureStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null } | { totalGas: string, totalFee: string, type: 'PreconfirmationSuccessStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null } | { reason: string, type: 'SqueezedOutStatus' } | { time: string, type: 'SubmittedStatus' } | { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', block: { id: string }, programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | null } | null };

export type GqlGetTransactionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetTransactionsQuery = { transactions: { edges: Array<{ node: { rawPayload: string } }>, pageInfo: { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type GqlGetTransactionsByOwnerQueryVariables = Exact<{
  owner: Scalars['Address']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetTransactionsByOwnerQuery = { transactionsByOwner: { pageInfo: { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ node: { id: string, rawPayload: string, status?: { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { reason: string, type: 'SqueezedOutStatus' } | { time: string, type: 'SubmittedStatus' } | { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | {} | null } }> } };

export type GqlEstimatePredicatesQueryVariables = Exact<{
  encodedTransaction: Scalars['HexString']['input'];
}>;


export type GqlEstimatePredicatesQuery = { estimatePredicates: { inputs?: Array<{ predicateGasUsed: string } | { predicateGasUsed: string } | {}> | null } };

export type GqlEstimatePredicatesAndGasPriceQueryVariables = Exact<{
  encodedTransaction: Scalars['HexString']['input'];
  blockHorizon: Scalars['U32']['input'];
}>;


export type GqlEstimatePredicatesAndGasPriceQuery = { estimatePredicates: { inputs?: Array<{ predicateGasUsed: string } | { predicateGasUsed: string } | {}> | null }, estimateGasPrice: { gasPrice: string } };

export type GqlGetLatestBlockQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetLatestBlockQuery = { chain: { latestBlock: { id: string, height: string, header: { time: string, daHeight: string, stateTransitionBytecodeVersion: string, transactionsCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, prevRoot: string, applicationHash: string }, transactions: Array<{ id: string }> } } };

export type GqlGetLatestBlockHeightQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetLatestBlockHeightQuery = { chain: { latestBlock: { height: string } } };

export type GqlGetBlockQueryVariables = Exact<{
  blockId?: InputMaybe<Scalars['BlockId']['input']>;
  height?: InputMaybe<Scalars['U32']['input']>;
}>;


export type GqlGetBlockQuery = { block?: { id: string, height: string, header: { time: string, daHeight: string, stateTransitionBytecodeVersion: string, transactionsCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, prevRoot: string, applicationHash: string }, transactions: Array<{ id: string }> } | null };

export type GqlGetBlockWithTransactionsQueryVariables = Exact<{
  blockId?: InputMaybe<Scalars['BlockId']['input']>;
  blockHeight?: InputMaybe<Scalars['U32']['input']>;
}>;


export type GqlGetBlockWithTransactionsQuery = { block?: { id: string, height: string, transactions: Array<{ id: string, rawPayload: string }>, header: { time: string, daHeight: string, stateTransitionBytecodeVersion: string, transactionsCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, prevRoot: string, applicationHash: string } } | null };

export type GqlGetBlocksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetBlocksQuery = { blocks: { pageInfo: { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ node: { id: string, height: string, header: { time: string, daHeight: string, stateTransitionBytecodeVersion: string, transactionsCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, prevRoot: string, applicationHash: string }, transactions: Array<{ id: string }> } }> } };

export type GqlGetCoinQueryVariables = Exact<{
  coinId: Scalars['UtxoId']['input'];
}>;


export type GqlGetCoinQuery = { coin?: { owner: string, utxoId: string, amount: string, assetId: string, blockCreated: string, txCreatedIdx: string, type: 'Coin' } | null };

export type GqlGetCoinsQueryVariables = Exact<{
  filter: GqlCoinFilterInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetCoinsQuery = { coins: { pageInfo: { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ node: { utxoId: string, amount: string, assetId: string, blockCreated: string, txCreatedIdx: string, type: 'Coin' } }> } };

export type GqlGetCoinsToSpendQueryVariables = Exact<{
  owner: Scalars['Address']['input'];
  queryPerAsset: Array<GqlSpendQueryElementInput> | GqlSpendQueryElementInput;
  excludedIds?: InputMaybe<GqlExcludeInput>;
}>;


export type GqlGetCoinsToSpendQuery = { coinsToSpend: Array<Array<{ utxoId: string, amount: string, assetId: string, blockCreated: string, txCreatedIdx: string, type: 'Coin' } | { sender: string, recipient: string, nonce: string, amount: string, assetId: string, daHeight: string, type: 'MessageCoin' }>> };

export type GqlGetContractQueryVariables = Exact<{
  contractId: Scalars['ContractId']['input'];
}>;


export type GqlGetContractQuery = { contract?: { bytecode: string, id: string } | null };

export type GqlGetContractBalanceQueryVariables = Exact<{
  contract: Scalars['ContractId']['input'];
  asset: Scalars['AssetId']['input'];
}>;


export type GqlGetContractBalanceQuery = { contractBalance: { contract: string, amount: string, assetId: string } };

export type GqlGetBalanceQueryVariables = Exact<{
  owner: Scalars['Address']['input'];
  assetId: Scalars['AssetId']['input'];
}>;


export type GqlGetBalanceQuery = { balance: { amount: string } };

export type GqlGetBalanceV2QueryVariables = Exact<{
  owner: Scalars['Address']['input'];
  assetId: Scalars['AssetId']['input'];
}>;


export type GqlGetBalanceV2Query = { balance: { amountU128: string } };

export type GqlGetLatestGasPriceQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetLatestGasPriceQuery = { latestGasPrice: { gasPrice: string } };

export type GqlEstimateGasPriceQueryVariables = Exact<{
  blockHorizon: Scalars['U32']['input'];
}>;


export type GqlEstimateGasPriceQuery = { estimateGasPrice: { gasPrice: string } };

export type GqlGetBalancesQueryVariables = Exact<{
  filter: GqlBalanceFilterInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetBalancesQuery = { balances: { edges: Array<{ node: { assetId: string, amount: string } }> } };

export type GqlGetBalancesV2QueryVariables = Exact<{
  filter: GqlBalanceFilterInput;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  supportsPagination: Scalars['Boolean']['input'];
}>;


export type GqlGetBalancesV2Query = { balances: { pageInfo?: { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ node: { assetId: string, amountU128: string } }> } };

export type GqlGetMessagesQueryVariables = Exact<{
  owner: Scalars['Address']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GqlGetMessagesQuery = { messages: { pageInfo: { hasPreviousPage: boolean, hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ node: { nonce: string, amount: string, sender: string, recipient: string, data: string, daHeight: string } }> } };

export type GqlDaCompressedBlockQueryVariables = Exact<{
  height: Scalars['U32']['input'];
}>;


export type GqlDaCompressedBlockQuery = { daCompressedBlock?: { bytes: string } | null };

export type GqlGetMessageProofQueryVariables = Exact<{
  transactionId: Scalars['TransactionId']['input'];
  nonce: Scalars['Nonce']['input'];
  commitBlockId?: InputMaybe<Scalars['BlockId']['input']>;
  commitBlockHeight?: InputMaybe<Scalars['U32']['input']>;
}>;


export type GqlGetMessageProofQuery = { messageProof: { sender: string, recipient: string, amount: string, data: string, messageProof: { proofSet: Array<string>, proofIndex: string }, blockProof: { proofSet: Array<string>, proofIndex: string }, messageBlockHeader: { version: GqlHeaderVersion, id: string, daHeight: string, consensusParametersVersion: string, stateTransitionBytecodeVersion: string, transactionsCount: string, messageReceiptCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, height: string, prevRoot: string, time: string, applicationHash: string }, commitBlockHeader: { version: GqlHeaderVersion, id: string, daHeight: string, consensusParametersVersion: string, stateTransitionBytecodeVersion: string, transactionsCount: string, messageReceiptCount: string, transactionsRoot: string, messageOutboxRoot: string, eventInboxRoot: string, height: string, prevRoot: string, time: string, applicationHash: string } } };

export type GqlGetMessageStatusQueryVariables = Exact<{
  nonce: Scalars['Nonce']['input'];
}>;


export type GqlGetMessageStatusQuery = { messageStatus: { state: GqlMessageState } };

export type GqlGetRelayedTransactionStatusQueryVariables = Exact<{
  relayedTransactionId: Scalars['RelayedTransactionId']['input'];
}>;


export type GqlGetRelayedTransactionStatusQuery = { relayedTransactionStatus?: { blockHeight: string, failure: string } | null };

export type GqlGetAssetDetailsQueryVariables = Exact<{
  assetId: Scalars['AssetId']['input'];
}>;


export type GqlGetAssetDetailsQuery = { assetDetails?: { subId: string, contractId: string, totalSupply: string } | null };

export type GqlAssembleTxQueryVariables = Exact<{
  tx: Scalars['HexString']['input'];
  blockHorizon: Scalars['U32']['input'];
  requiredBalances: Array<GqlRequiredBalance> | GqlRequiredBalance;
  feeAddressIndex: Scalars['U16']['input'];
  excludeInput?: InputMaybe<GqlExcludeInput>;
  estimatePredicates?: InputMaybe<Scalars['Boolean']['input']>;
  reserveGas?: InputMaybe<Scalars['U64']['input']>;
}>;


export type GqlAssembleTxQuery = { assembleTx: { gasPrice: string, transaction: { id: string, witnesses?: Array<string> | null, scriptGasLimit?: string | null, inputs?: Array<{ utxoId: string, owner: string, amount: string, assetId: string, txPointer: string, predicateGasUsed: string, predicate: string, predicateData: string, type: 'InputCoin', coinWitnessIndex: string } | { utxoId: string, balanceRoot: string, stateRoot: string, txPointer: string, contractId: string, type: 'InputContract' } | { sender: string, recipient: string, amount: string, nonce: string, predicateGasUsed: string, data: string, predicate: string, predicateData: string, type: 'InputMessage', messageWitnessIndex: string }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }>, policies?: { tip?: string | null, witnessLimit?: string | null, maturity?: string | null, maxFee?: string | null } | null }, status: { reason: string, type: 'DryRunFailureStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { type: 'DryRunSuccessStatus', receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } } };

export type GqlDryRunQueryVariables = Exact<{
  encodedTransactions: Array<Scalars['HexString']['input']> | Scalars['HexString']['input'];
  utxoValidation?: InputMaybe<Scalars['Boolean']['input']>;
  gasPrice?: InputMaybe<Scalars['U64']['input']>;
}>;


export type GqlDryRunQuery = { dryRun: Array<{ id: string, status: { totalGas: string, totalFee: string, reason: string, type: 'DryRunFailureStatus', programState?: { returnType: GqlReturnType, data: string } | null } | { totalGas: string, totalFee: string, type: 'DryRunSuccessStatus', programState?: { returnType: GqlReturnType, data: string } | null }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> }> };

export type GqlSubmitMutationVariables = Exact<{
  encodedTransaction: Scalars['HexString']['input'];
}>;


export type GqlSubmitMutation = { submit: { id: string } };

export type GqlProduceBlocksMutationVariables = Exact<{
  startTimestamp?: InputMaybe<Scalars['Tai64Timestamp']['input']>;
  blocksToProduce: Scalars['U32']['input'];
}>;


export type GqlProduceBlocksMutation = { produceBlocks: string };

export type GqlGetMessageByNonceQueryVariables = Exact<{
  nonce: Scalars['Nonce']['input'];
}>;


export type GqlGetMessageByNonceQuery = { message?: { amount: string, sender: string, recipient: string, data: string, daHeight: string } | null };

export type GqlIsUserAccountQueryVariables = Exact<{
  blobId: Scalars['BlobId']['input'];
  contractId: Scalars['ContractId']['input'];
  transactionId: Scalars['TransactionId']['input'];
}>;


export type GqlIsUserAccountQuery = { blob?: { id: any } | null, contract?: { id: string } | null, transaction?: { id: string } | null };

export type GqlGetConsensusParametersVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GqlGetConsensusParametersVersionQuery = { chain: { latestBlock: { header: { consensusParametersVersion: string } } } };

export type GqlSubmitAndAwaitStatusSubscriptionVariables = Exact<{
  encodedTransaction: Scalars['HexString']['input'];
  estimatePredicates?: InputMaybe<Scalars['Boolean']['input']>;
  includePreConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlSubmitAndAwaitStatusSubscription = { submitAndAwaitStatus: { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', transaction: { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> }, block: { id: string }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { reason: string, totalGas: string, totalFee: string, type: 'PreconfirmationFailureStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null } | { totalGas: string, totalFee: string, type: 'PreconfirmationSuccessStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null } | { reason: string, type: 'SqueezedOutStatus' } | { time: string, type: 'SubmittedStatus' } | { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', transaction: { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> }, block: { id: string }, programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } };

export type GqlStatusChangeSubscriptionVariables = Exact<{
  transactionId: Scalars['TransactionId']['input'];
  includePreConfirmation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GqlStatusChangeSubscription = { statusChange: { totalGas: string, totalFee: string, time: string, reason: string, type: 'FailureStatus', transaction: { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> }, block: { id: string }, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } | { reason: string, totalGas: string, totalFee: string, type: 'PreconfirmationFailureStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null } | { totalGas: string, totalFee: string, type: 'PreconfirmationSuccessStatus', resolvedOutputs?: Array<{ utxoId: string, output: { to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' } }> | null, preconfirmationReceipts?: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> | null } | { reason: string, type: 'SqueezedOutStatus' } | { time: string, type: 'SubmittedStatus' } | { time: string, totalGas: string, totalFee: string, type: 'SuccessStatus', transaction: { receiptsRoot?: string | null, inputs?: Array<{ txPointer: string, type: 'InputCoin' } | { txPointer: string, type: 'InputContract' } | { type: 'InputMessage' }> | null, outputs: Array<{ to: string, amount: string, assetId: string, type: 'ChangeOutput' } | { to: string, amount: string, assetId: string, type: 'CoinOutput' } | { contract: string, stateRoot: string, type: 'ContractCreated' } | { inputIndex: string, balanceRoot: string, stateRoot: string, type: 'ContractOutput' } | { to: string, amount: string, assetId: string, type: 'VariableOutput' }> }, block: { id: string }, programState?: { returnType: GqlReturnType, data: string } | null, receipts: Array<{ id?: string | null, pc?: string | null, is?: string | null, to?: string | null, toAddress?: string | null, amount?: string | null, assetId?: string | null, gas?: string | null, param1?: string | null, param2?: string | null, val?: string | null, ptr?: string | null, digest?: string | null, reason?: string | null, ra?: string | null, rb?: string | null, rc?: string | null, rd?: string | null, len?: string | null, receiptType: GqlReceiptType, result?: string | null, gasUsed?: string | null, data?: string | null, sender?: string | null, recipient?: string | null, nonce?: string | null, contractId?: string | null, subId?: string | null }> } };

export const InputCoinFragmentDoc = gql`
    fragment InputCoinFragment on InputCoin {
  type: __typename
  utxoId
  owner
  amount
  assetId
  txPointer
  coinWitnessIndex: witnessIndex
  predicateGasUsed
  predicate
  predicateData
}
    `;
export const InputMessageFragmentDoc = gql`
    fragment InputMessageFragment on InputMessage {
  type: __typename
  sender
  recipient
  amount
  nonce
  messageWitnessIndex: witnessIndex
  predicateGasUsed
  data
  predicate
  predicateData
}
    `;
export const InputContractFragmentDoc = gql`
    fragment InputContractFragment on InputContract {
  type: __typename
  utxoId
  balanceRoot
  stateRoot
  txPointer
  contractId
}
    `;
export const OutputCoinFragmentDoc = gql`
    fragment OutputCoinFragment on CoinOutput {
  type: __typename
  to
  amount
  assetId
}
    `;
export const OutputContractFragmentDoc = gql`
    fragment OutputContractFragment on ContractOutput {
  type: __typename
  inputIndex
  balanceRoot
  stateRoot
}
    `;
export const OutputChangeFragmentDoc = gql`
    fragment OutputChangeFragment on ChangeOutput {
  type: __typename
  to
  amount
  assetId
}
    `;
export const OutputVariableFragmentDoc = gql`
    fragment OutputVariableFragment on VariableOutput {
  type: __typename
  to
  amount
  assetId
}
    `;
export const OutputContractCreatedFragmentDoc = gql`
    fragment OutputContractCreatedFragment on ContractCreated {
  type: __typename
  contract
  stateRoot
}
    `;
export const SubmittedStatusFragmentDoc = gql`
    fragment SubmittedStatusFragment on SubmittedStatus {
  type: __typename
  time
}
    `;
export const ReceiptFragmentDoc = gql`
    fragment receiptFragment on Receipt {
  id
  pc
  is
  to
  toAddress
  amount
  assetId
  gas
  param1
  param2
  val
  ptr
  digest
  reason
  ra
  rb
  rc
  rd
  len
  receiptType
  result
  gasUsed
  data
  sender
  recipient
  nonce
  contractId
  subId
}
    `;
export const SuccessStatusFragmentDoc = gql`
    fragment SuccessStatusFragment on SuccessStatus {
  type: __typename
  time
  programState {
    returnType
    data
  }
  receipts {
    ...receiptFragment
  }
  totalGas
  totalFee
}
    ${ReceiptFragmentDoc}`;
export const SuccessStatusWithBlockIdFragmentDoc = gql`
    fragment SuccessStatusWithBlockIdFragment on SuccessStatus {
  ...SuccessStatusFragment
  block {
    id
  }
}
    ${SuccessStatusFragmentDoc}`;
export const MalleableTransactionFieldsFragmentDoc = gql`
    fragment malleableTransactionFieldsFragment on Transaction {
  receiptsRoot
  inputs {
    type: __typename
    ... on InputCoin {
      txPointer
    }
    ... on InputContract {
      txPointer
    }
  }
  outputs {
    type: __typename
    ... on CoinOutput {
      to
      amount
      assetId
    }
    ... on ContractOutput {
      inputIndex
      balanceRoot
      stateRoot
    }
    ... on ChangeOutput {
      to
      amount
      assetId
    }
    ... on VariableOutput {
      to
      amount
      assetId
    }
    ... on ContractCreated {
      contract
      stateRoot
    }
  }
}
    `;
export const FailureStatusFragmentDoc = gql`
    fragment FailureStatusFragment on FailureStatus {
  type: __typename
  totalGas
  totalFee
  time
  reason
  receipts {
    ...receiptFragment
  }
}
    ${ReceiptFragmentDoc}`;
export const FailureStatusWithBlockIdFragmentDoc = gql`
    fragment FailureStatusWithBlockIdFragment on FailureStatus {
  ...FailureStatusFragment
  block {
    id
  }
}
    ${FailureStatusFragmentDoc}`;
export const SqueezedOutStatusFragmentDoc = gql`
    fragment SqueezedOutStatusFragment on SqueezedOutStatus {
  type: __typename
  reason
}
    `;
export const PreconfirmationSuccessStatusFragmentDoc = gql`
    fragment PreconfirmationSuccessStatusFragment on PreconfirmationSuccessStatus {
  type: __typename
  totalGas
  totalFee
  resolvedOutputs {
    utxoId
    output {
      type: __typename
      ... on CoinOutput {
        to
        amount
        assetId
      }
      ... on ContractOutput {
        inputIndex
        balanceRoot
        stateRoot
      }
      ... on ChangeOutput {
        to
        amount
        assetId
      }
      ... on VariableOutput {
        to
        amount
        assetId
      }
      ... on ContractCreated {
        contract
        stateRoot
      }
    }
  }
  preconfirmationReceipts: receipts {
    ...receiptFragment
  }
}
    ${ReceiptFragmentDoc}`;
export const PreconfirmationFailureStatusFragmentDoc = gql`
    fragment PreconfirmationFailureStatusFragment on PreconfirmationFailureStatus {
  type: __typename
  reason
  totalGas
  totalFee
  resolvedOutputs {
    utxoId
    output {
      type: __typename
      ... on CoinOutput {
        to
        amount
        assetId
      }
      ... on ContractOutput {
        inputIndex
        balanceRoot
        stateRoot
      }
      ... on ChangeOutput {
        to
        amount
        assetId
      }
      ... on VariableOutput {
        to
        amount
        assetId
      }
      ... on ContractCreated {
        contract
        stateRoot
      }
    }
  }
  preconfirmationReceipts: receipts {
    ...receiptFragment
  }
}
    ${ReceiptFragmentDoc}`;
export const TransactionStatusSubscriptionFragmentDoc = gql`
    fragment transactionStatusSubscriptionFragment on TransactionStatus {
  ... on SubmittedStatus {
    ...SubmittedStatusFragment
  }
  ... on SuccessStatus {
    ...SuccessStatusWithBlockIdFragment
    transaction {
      ...malleableTransactionFieldsFragment
    }
  }
  ... on FailureStatus {
    ...FailureStatusWithBlockIdFragment
    transaction {
      ...malleableTransactionFieldsFragment
    }
  }
  ... on SqueezedOutStatus {
    ...SqueezedOutStatusFragment
  }
  ... on PreconfirmationSuccessStatus {
    ...PreconfirmationSuccessStatusFragment
  }
  ... on PreconfirmationFailureStatus {
    ...PreconfirmationFailureStatusFragment
  }
}
    ${SubmittedStatusFragmentDoc}
${SuccessStatusWithBlockIdFragmentDoc}
${MalleableTransactionFieldsFragmentDoc}
${FailureStatusWithBlockIdFragmentDoc}
${SqueezedOutStatusFragmentDoc}
${PreconfirmationSuccessStatusFragmentDoc}
${PreconfirmationFailureStatusFragmentDoc}`;
export const TransactionStatusFragmentDoc = gql`
    fragment transactionStatusFragment on TransactionStatus {
  ... on SubmittedStatus {
    ...SubmittedStatusFragment
  }
  ... on SuccessStatus {
    ...SuccessStatusFragment
  }
  ... on FailureStatus {
    ...FailureStatusFragment
  }
  ... on SqueezedOutStatus {
    ...SqueezedOutStatusFragment
  }
}
    ${SubmittedStatusFragmentDoc}
${SuccessStatusFragmentDoc}
${FailureStatusFragmentDoc}
${SqueezedOutStatusFragmentDoc}`;
export const TransactionFragmentDoc = gql`
    fragment transactionFragment on Transaction {
  id
  rawPayload
  status {
    ...transactionStatusFragment
  }
}
    ${TransactionStatusFragmentDoc}`;
export const TransactionRawPayloadFragmentDoc = gql`
    fragment transactionRawPayloadFragment on Transaction {
  id
  rawPayload
}
    `;
export const InputEstimatePredicatesFragmentDoc = gql`
    fragment inputEstimatePredicatesFragment on Input {
  ... on InputCoin {
    predicateGasUsed
  }
  ... on InputMessage {
    predicateGasUsed
  }
}
    `;
export const TransactionEstimatePredicatesFragmentDoc = gql`
    fragment transactionEstimatePredicatesFragment on Transaction {
  inputs {
    ...inputEstimatePredicatesFragment
  }
}
    ${InputEstimatePredicatesFragmentDoc}`;
export const DryRunFailureAssembleTxFragmentDoc = gql`
    fragment dryRunFailureAssembleTxFragment on DryRunFailureStatus {
  type: __typename
  reason
  receipts {
    ...receiptFragment
  }
}
    ${ReceiptFragmentDoc}`;
export const DryRunSuccessAssembleTxFragmentDoc = gql`
    fragment dryRunSuccessAssembleTxFragment on DryRunSuccessStatus {
  type: __typename
  receipts {
    ...receiptFragment
  }
}
    ${ReceiptFragmentDoc}`;
export const DryRunFailureStatusFragmentDoc = gql`
    fragment dryRunFailureStatusFragment on DryRunFailureStatus {
  type: __typename
  totalGas
  totalFee
  reason
  programState {
    returnType
    data
  }
}
    `;
export const DryRunSuccessStatusFragmentDoc = gql`
    fragment dryRunSuccessStatusFragment on DryRunSuccessStatus {
  type: __typename
  totalGas
  totalFee
  programState {
    returnType
    data
  }
}
    `;
export const DryRunTransactionStatusFragmentDoc = gql`
    fragment dryRunTransactionStatusFragment on DryRunTransactionStatus {
  ... on DryRunFailureStatus {
    ...dryRunFailureStatusFragment
  }
  ... on DryRunSuccessStatus {
    ...dryRunSuccessStatusFragment
  }
}
    ${DryRunFailureStatusFragmentDoc}
${DryRunSuccessStatusFragmentDoc}`;
export const DryRunTransactionExecutionStatusFragmentDoc = gql`
    fragment dryRunTransactionExecutionStatusFragment on DryRunTransactionExecutionStatus {
  id
  status {
    ...dryRunTransactionStatusFragment
  }
  receipts {
    ...receiptFragment
  }
}
    ${DryRunTransactionStatusFragmentDoc}
${ReceiptFragmentDoc}`;
export const BlockFragmentDoc = gql`
    fragment blockFragment on Block {
  id
  height
  header {
    time
    daHeight
    stateTransitionBytecodeVersion
    transactionsCount
    transactionsRoot
    messageOutboxRoot
    eventInboxRoot
    prevRoot
    applicationHash
  }
  transactions {
    id
  }
}
    `;
export const CoinFragmentDoc = gql`
    fragment coinFragment on Coin {
  type: __typename
  utxoId
  amount
  assetId
  blockCreated
  txCreatedIdx
}
    `;
export const MessageCoinFragmentDoc = gql`
    fragment messageCoinFragment on MessageCoin {
  type: __typename
  sender
  recipient
  nonce
  amount
  assetId
  daHeight
}
    `;
export const MessageFragmentDoc = gql`
    fragment messageFragment on Message {
  amount
  sender
  recipient
  data
  daHeight
}
    `;
export const GetMessageFragmentDoc = gql`
    fragment getMessageFragment on Message {
  ...messageFragment
  nonce
}
    ${MessageFragmentDoc}`;
export const MessageProofFragmentDoc = gql`
    fragment messageProofFragment on MessageProof {
  messageProof {
    proofSet
    proofIndex
  }
  blockProof {
    proofSet
    proofIndex
  }
  messageBlockHeader {
    version
    id
    daHeight
    consensusParametersVersion
    stateTransitionBytecodeVersion
    transactionsCount
    messageReceiptCount
    transactionsRoot
    messageOutboxRoot
    eventInboxRoot
    height
    prevRoot
    time
    applicationHash
  }
  commitBlockHeader {
    version
    id
    daHeight
    consensusParametersVersion
    stateTransitionBytecodeVersion
    transactionsCount
    messageReceiptCount
    transactionsRoot
    messageOutboxRoot
    eventInboxRoot
    height
    prevRoot
    time
    applicationHash
  }
  sender
  recipient
  amount
  data
}
    `;
export const TxParametersFragmentDoc = gql`
    fragment TxParametersFragment on TxParameters {
  version
  maxInputs
  maxOutputs
  maxWitnesses
  maxGasPerTx
  maxSize
  maxBytecodeSubsections
}
    `;
export const PredicateParametersFragmentDoc = gql`
    fragment PredicateParametersFragment on PredicateParameters {
  version
  maxPredicateLength
  maxPredicateDataLength
  maxGasPerPredicate
  maxMessageDataLength
}
    `;
export const ScriptParametersFragmentDoc = gql`
    fragment ScriptParametersFragment on ScriptParameters {
  version
  maxScriptLength
  maxScriptDataLength
}
    `;
export const ContractParametersFragmentDoc = gql`
    fragment ContractParametersFragment on ContractParameters {
  version
  contractMaxSize
  maxStorageSlots
}
    `;
export const FeeParametersFragmentDoc = gql`
    fragment FeeParametersFragment on FeeParameters {
  version
  gasPriceFactor
  gasPerByte
}
    `;
export const DependentCostFragmentDoc = gql`
    fragment DependentCostFragment on DependentCost {
  ... on LightOperation {
    type: __typename
    base
    unitsPerGas
  }
  ... on HeavyOperation {
    type: __typename
    base
    gasPerUnit
  }
}
    `;
export const GasCostsFragmentDoc = gql`
    fragment GasCostsFragment on GasCosts {
  contractRoot {
    ...DependentCostFragment
  }
  stateRoot {
    ...DependentCostFragment
  }
  vmInitialization {
    ...DependentCostFragment
  }
  s256 {
    ...DependentCostFragment
  }
  ecr1
  newStoragePerByte
}
    ${DependentCostFragmentDoc}`;
export const ConsensusParametersFragmentDoc = gql`
    fragment consensusParametersFragment on ConsensusParameters {
  version
  txParams {
    ...TxParametersFragment
  }
  predicateParams {
    ...PredicateParametersFragment
  }
  scriptParams {
    ...ScriptParametersFragment
  }
  contractParams {
    ...ContractParametersFragment
  }
  feeParams {
    ...FeeParametersFragment
  }
  gasCosts {
    ...GasCostsFragment
  }
  baseAssetId
  chainId
}
    ${TxParametersFragmentDoc}
${PredicateParametersFragmentDoc}
${ScriptParametersFragmentDoc}
${ContractParametersFragmentDoc}
${FeeParametersFragmentDoc}
${GasCostsFragmentDoc}`;
export const ChainInfoFragmentDoc = gql`
    fragment chainInfoFragment on ChainInfo {
  name
  daHeight
  consensusParameters {
    ...consensusParametersFragment
  }
  latestBlock {
    header {
      consensusParametersVersion
    }
  }
}
    ${ConsensusParametersFragmentDoc}`;
export const ContractBalanceFragmentDoc = gql`
    fragment contractBalanceFragment on ContractBalance {
  contract
  amount
  assetId
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment pageInfoFragment on PageInfo {
  hasPreviousPage
  hasNextPage
  startCursor
  endCursor
}
    `;
export const NodeInfoFragmentDoc = gql`
    fragment nodeInfoFragment on NodeInfo {
  utxoValidation
  vmBacktrace
  maxTx
  maxDepth
  nodeVersion
  indexation {
    balances
    coinsToSpend
    assetMetadata
  }
}
    `;
export const RelayedTransactionStatusFragmentDoc = gql`
    fragment relayedTransactionStatusFragment on RelayedTransactionStatus {
  ... on RelayedTransactionFailed {
    blockHeight
    failure
  }
}
    `;
export const GetVersionDocument = gql`
    query getVersion {
  nodeInfo {
    nodeVersion
  }
}
    `;
export const GetNodeInfoDocument = gql`
    query getNodeInfo {
  nodeInfo {
    ...nodeInfoFragment
  }
}
    ${NodeInfoFragmentDoc}`;
export const GetChainDocument = gql`
    query getChain {
  chain {
    ...chainInfoFragment
  }
}
    ${ChainInfoFragmentDoc}`;
export const GetChainAndNodeInfoDocument = gql`
    query getChainAndNodeInfo {
  chain {
    ...chainInfoFragment
  }
  nodeInfo {
    ...nodeInfoFragment
  }
}
    ${ChainInfoFragmentDoc}
${NodeInfoFragmentDoc}`;
export const GetTransactionDocument = gql`
    query getTransaction($transactionId: TransactionId!) {
  transaction(id: $transactionId) {
    ...transactionFragment
  }
}
    ${TransactionFragmentDoc}`;
export const GetTransactionWithReceiptsDocument = gql`
    query getTransactionWithReceipts($transactionId: TransactionId!) {
  transaction(id: $transactionId) {
    id
    rawPayload
    status {
      ... on SubmittedStatus {
        ...SubmittedStatusFragment
      }
      ... on SuccessStatus {
        ...SuccessStatusWithBlockIdFragment
      }
      ... on FailureStatus {
        ...FailureStatusWithBlockIdFragment
      }
      ... on SqueezedOutStatus {
        ...SqueezedOutStatusFragment
      }
      ... on PreconfirmationSuccessStatus {
        ...PreconfirmationSuccessStatusFragment
      }
      ... on PreconfirmationFailureStatus {
        ...PreconfirmationFailureStatusFragment
      }
    }
  }
}
    ${SubmittedStatusFragmentDoc}
${SuccessStatusWithBlockIdFragmentDoc}
${FailureStatusWithBlockIdFragmentDoc}
${SqueezedOutStatusFragmentDoc}
${PreconfirmationSuccessStatusFragmentDoc}
${PreconfirmationFailureStatusFragmentDoc}`;
export const GetTransactionsDocument = gql`
    query getTransactions($after: String, $before: String, $first: Int, $last: Int) {
  transactions(after: $after, before: $before, first: $first, last: $last) {
    edges {
      node {
        rawPayload
      }
    }
    pageInfo {
      ...pageInfoFragment
    }
  }
}
    ${PageInfoFragmentDoc}`;
export const GetTransactionsByOwnerDocument = gql`
    query getTransactionsByOwner($owner: Address!, $after: String, $before: String, $first: Int, $last: Int) {
  transactionsByOwner(
    owner: $owner
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfoFragment
    }
    edges {
      node {
        ...transactionFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${TransactionFragmentDoc}`;
export const EstimatePredicatesDocument = gql`
    query estimatePredicates($encodedTransaction: HexString!) {
  estimatePredicates(tx: $encodedTransaction) {
    ...transactionEstimatePredicatesFragment
  }
}
    ${TransactionEstimatePredicatesFragmentDoc}`;
export const EstimatePredicatesAndGasPriceDocument = gql`
    query estimatePredicatesAndGasPrice($encodedTransaction: HexString!, $blockHorizon: U32!) {
  estimatePredicates(tx: $encodedTransaction) {
    ...transactionEstimatePredicatesFragment
  }
  estimateGasPrice(blockHorizon: $blockHorizon) {
    gasPrice
  }
}
    ${TransactionEstimatePredicatesFragmentDoc}`;
export const GetLatestBlockDocument = gql`
    query getLatestBlock {
  chain {
    latestBlock {
      ...blockFragment
    }
  }
}
    ${BlockFragmentDoc}`;
export const GetLatestBlockHeightDocument = gql`
    query getLatestBlockHeight {
  chain {
    latestBlock {
      height
    }
  }
}
    `;
export const GetBlockDocument = gql`
    query getBlock($blockId: BlockId, $height: U32) {
  block(id: $blockId, height: $height) {
    ...blockFragment
  }
}
    ${BlockFragmentDoc}`;
export const GetBlockWithTransactionsDocument = gql`
    query getBlockWithTransactions($blockId: BlockId, $blockHeight: U32) {
  block(id: $blockId, height: $blockHeight) {
    ...blockFragment
    transactions {
      ...transactionRawPayloadFragment
    }
  }
}
    ${BlockFragmentDoc}
${TransactionRawPayloadFragmentDoc}`;
export const GetBlocksDocument = gql`
    query getBlocks($after: String, $before: String, $first: Int, $last: Int) {
  blocks(after: $after, before: $before, first: $first, last: $last) {
    pageInfo {
      ...pageInfoFragment
    }
    edges {
      node {
        ...blockFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${BlockFragmentDoc}`;
export const GetCoinDocument = gql`
    query getCoin($coinId: UtxoId!) {
  coin(utxoId: $coinId) {
    ...coinFragment
    owner
  }
}
    ${CoinFragmentDoc}`;
export const GetCoinsDocument = gql`
    query getCoins($filter: CoinFilterInput!, $after: String, $before: String, $first: Int, $last: Int) {
  coins(
    filter: $filter
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfoFragment
    }
    edges {
      node {
        ...coinFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${CoinFragmentDoc}`;
export const GetCoinsToSpendDocument = gql`
    query getCoinsToSpend($owner: Address!, $queryPerAsset: [SpendQueryElementInput!]!, $excludedIds: ExcludeInput) {
  coinsToSpend(
    owner: $owner
    queryPerAsset: $queryPerAsset
    excludedIds: $excludedIds
  ) {
    ...coinFragment
    ...messageCoinFragment
  }
}
    ${CoinFragmentDoc}
${MessageCoinFragmentDoc}`;
export const GetContractDocument = gql`
    query getContract($contractId: ContractId!) {
  contract(id: $contractId) {
    bytecode
    id
  }
}
    `;
export const GetContractBalanceDocument = gql`
    query getContractBalance($contract: ContractId!, $asset: AssetId!) {
  contractBalance(contract: $contract, asset: $asset) {
    ...contractBalanceFragment
  }
}
    ${ContractBalanceFragmentDoc}`;
export const GetBalanceDocument = gql`
    query getBalance($owner: Address!, $assetId: AssetId!) {
  balance(owner: $owner, assetId: $assetId) {
    amount
  }
}
    `;
export const GetBalanceV2Document = gql`
    query getBalanceV2($owner: Address!, $assetId: AssetId!) {
  balance(owner: $owner, assetId: $assetId) {
    amountU128
  }
}
    `;
export const GetLatestGasPriceDocument = gql`
    query getLatestGasPrice {
  latestGasPrice {
    gasPrice
  }
}
    `;
export const EstimateGasPriceDocument = gql`
    query estimateGasPrice($blockHorizon: U32!) {
  estimateGasPrice(blockHorizon: $blockHorizon) {
    gasPrice
  }
}
    `;
export const GetBalancesDocument = gql`
    query getBalances($filter: BalanceFilterInput!, $after: String, $before: String, $first: Int, $last: Int) {
  balances(
    filter: $filter
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    edges {
      node {
        assetId
        amount
      }
    }
  }
}
    `;
export const GetBalancesV2Document = gql`
    query getBalancesV2($filter: BalanceFilterInput!, $after: String, $before: String, $first: Int, $last: Int, $supportsPagination: Boolean!) {
  balances(
    filter: $filter
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo @include(if: $supportsPagination) {
      ...pageInfoFragment
    }
    edges {
      node {
        assetId
        amountU128
      }
    }
  }
}
    ${PageInfoFragmentDoc}`;
export const GetMessagesDocument = gql`
    query getMessages($owner: Address!, $after: String, $before: String, $first: Int, $last: Int) {
  messages(
    owner: $owner
    after: $after
    before: $before
    first: $first
    last: $last
  ) {
    pageInfo {
      ...pageInfoFragment
    }
    edges {
      node {
        ...getMessageFragment
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${GetMessageFragmentDoc}`;
export const DaCompressedBlockDocument = gql`
    query daCompressedBlock($height: U32!) {
  daCompressedBlock(height: $height) {
    bytes
  }
}
    `;
export const GetMessageProofDocument = gql`
    query getMessageProof($transactionId: TransactionId!, $nonce: Nonce!, $commitBlockId: BlockId, $commitBlockHeight: U32) {
  messageProof(
    transactionId: $transactionId
    nonce: $nonce
    commitBlockId: $commitBlockId
    commitBlockHeight: $commitBlockHeight
  ) {
    ...messageProofFragment
  }
}
    ${MessageProofFragmentDoc}`;
export const GetMessageStatusDocument = gql`
    query getMessageStatus($nonce: Nonce!) {
  messageStatus(nonce: $nonce) {
    state
  }
}
    `;
export const GetRelayedTransactionStatusDocument = gql`
    query getRelayedTransactionStatus($relayedTransactionId: RelayedTransactionId!) {
  relayedTransactionStatus(id: $relayedTransactionId) {
    ...relayedTransactionStatusFragment
  }
}
    ${RelayedTransactionStatusFragmentDoc}`;
export const GetAssetDetailsDocument = gql`
    query getAssetDetails($assetId: AssetId!) {
  assetDetails(id: $assetId) {
    subId
    contractId
    totalSupply
  }
}
    `;
export const AssembleTxDocument = gql`
    query assembleTx($tx: HexString!, $blockHorizon: U32!, $requiredBalances: [RequiredBalance!]!, $feeAddressIndex: U16!, $excludeInput: ExcludeInput, $estimatePredicates: Boolean, $reserveGas: U64) {
  assembleTx(
    tx: $tx
    blockHorizon: $blockHorizon
    requiredBalances: $requiredBalances
    feeAddressIndex: $feeAddressIndex
    excludeInput: $excludeInput
    estimatePredicates: $estimatePredicates
    reserveGas: $reserveGas
  ) {
    transaction {
      id
      inputs {
        ... on InputCoin {
          ...InputCoinFragment
        }
        ... on InputContract {
          ...InputContractFragment
        }
        ... on InputMessage {
          ...InputMessageFragment
        }
      }
      outputs {
        ... on CoinOutput {
          ...OutputCoinFragment
        }
        ... on ContractOutput {
          ...OutputContractFragment
        }
        ... on ChangeOutput {
          ...OutputChangeFragment
        }
        ... on VariableOutput {
          ...OutputVariableFragment
        }
        ... on ContractCreated {
          ...OutputContractCreatedFragment
        }
      }
      policies {
        tip
        witnessLimit
        maturity
        maxFee
      }
      witnesses
      scriptGasLimit
    }
    status {
      ... on DryRunFailureStatus {
        ...dryRunFailureAssembleTxFragment
      }
      ... on DryRunSuccessStatus {
        ...dryRunSuccessAssembleTxFragment
      }
    }
    gasPrice
  }
}
    ${InputCoinFragmentDoc}
${InputContractFragmentDoc}
${InputMessageFragmentDoc}
${OutputCoinFragmentDoc}
${OutputContractFragmentDoc}
${OutputChangeFragmentDoc}
${OutputVariableFragmentDoc}
${OutputContractCreatedFragmentDoc}
${DryRunFailureAssembleTxFragmentDoc}
${DryRunSuccessAssembleTxFragmentDoc}`;
export const DryRunDocument = gql`
    query dryRun($encodedTransactions: [HexString!]!, $utxoValidation: Boolean, $gasPrice: U64) {
  dryRun(
    txs: $encodedTransactions
    utxoValidation: $utxoValidation
    gasPrice: $gasPrice
  ) {
    ...dryRunTransactionExecutionStatusFragment
  }
}
    ${DryRunTransactionExecutionStatusFragmentDoc}`;
export const SubmitDocument = gql`
    mutation submit($encodedTransaction: HexString!) {
  submit(tx: $encodedTransaction) {
    id
  }
}
    `;
export const ProduceBlocksDocument = gql`
    mutation produceBlocks($startTimestamp: Tai64Timestamp, $blocksToProduce: U32!) {
  produceBlocks(
    blocksToProduce: $blocksToProduce
    startTimestamp: $startTimestamp
  )
}
    `;
export const GetMessageByNonceDocument = gql`
    query getMessageByNonce($nonce: Nonce!) {
  message(nonce: $nonce) {
    ...messageFragment
  }
}
    ${MessageFragmentDoc}`;
export const IsUserAccountDocument = gql`
    query isUserAccount($blobId: BlobId!, $contractId: ContractId!, $transactionId: TransactionId!) {
  blob(id: $blobId) {
    id
  }
  contract(id: $contractId) {
    id
  }
  transaction(id: $transactionId) {
    id
  }
}
    `;
export const GetConsensusParametersVersionDocument = gql`
    query getConsensusParametersVersion {
  chain {
    latestBlock {
      header {
        consensusParametersVersion
      }
    }
  }
}
    `;
export const SubmitAndAwaitStatusDocument = gql`
    subscription submitAndAwaitStatus($encodedTransaction: HexString!, $estimatePredicates: Boolean, $includePreConfirmation: Boolean) {
  submitAndAwaitStatus(
    tx: $encodedTransaction
    estimatePredicates: $estimatePredicates
    includePreconfirmation: $includePreConfirmation
  ) {
    ...transactionStatusSubscriptionFragment
  }
}
    ${TransactionStatusSubscriptionFragmentDoc}`;
export const StatusChangeDocument = gql`
    subscription statusChange($transactionId: TransactionId!, $includePreConfirmation: Boolean) {
  statusChange(
    id: $transactionId
    includePreconfirmation: $includePreConfirmation
  ) {
    ...transactionStatusSubscriptionFragment
  }
}
    ${TransactionStatusSubscriptionFragmentDoc}`;
export type Requester<C = {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C>(requester: Requester<C>) {
  return {
    getVersion(variables?: GqlGetVersionQueryVariables, options?: C): Promise<GqlGetVersionQuery> {
      return requester<GqlGetVersionQuery, GqlGetVersionQueryVariables>(GetVersionDocument, variables, options) as Promise<GqlGetVersionQuery>;
    },
    getNodeInfo(variables?: GqlGetNodeInfoQueryVariables, options?: C): Promise<GqlGetNodeInfoQuery> {
      return requester<GqlGetNodeInfoQuery, GqlGetNodeInfoQueryVariables>(GetNodeInfoDocument, variables, options) as Promise<GqlGetNodeInfoQuery>;
    },
    getChain(variables?: GqlGetChainQueryVariables, options?: C): Promise<GqlGetChainQuery> {
      return requester<GqlGetChainQuery, GqlGetChainQueryVariables>(GetChainDocument, variables, options) as Promise<GqlGetChainQuery>;
    },
    getChainAndNodeInfo(variables?: GqlGetChainAndNodeInfoQueryVariables, options?: C): Promise<GqlGetChainAndNodeInfoQuery> {
      return requester<GqlGetChainAndNodeInfoQuery, GqlGetChainAndNodeInfoQueryVariables>(GetChainAndNodeInfoDocument, variables, options) as Promise<GqlGetChainAndNodeInfoQuery>;
    },
    getTransaction(variables: GqlGetTransactionQueryVariables, options?: C): Promise<GqlGetTransactionQuery> {
      return requester<GqlGetTransactionQuery, GqlGetTransactionQueryVariables>(GetTransactionDocument, variables, options) as Promise<GqlGetTransactionQuery>;
    },
    getTransactionWithReceipts(variables: GqlGetTransactionWithReceiptsQueryVariables, options?: C): Promise<GqlGetTransactionWithReceiptsQuery> {
      return requester<GqlGetTransactionWithReceiptsQuery, GqlGetTransactionWithReceiptsQueryVariables>(GetTransactionWithReceiptsDocument, variables, options) as Promise<GqlGetTransactionWithReceiptsQuery>;
    },
    getTransactions(variables?: GqlGetTransactionsQueryVariables, options?: C): Promise<GqlGetTransactionsQuery> {
      return requester<GqlGetTransactionsQuery, GqlGetTransactionsQueryVariables>(GetTransactionsDocument, variables, options) as Promise<GqlGetTransactionsQuery>;
    },
    getTransactionsByOwner(variables: GqlGetTransactionsByOwnerQueryVariables, options?: C): Promise<GqlGetTransactionsByOwnerQuery> {
      return requester<GqlGetTransactionsByOwnerQuery, GqlGetTransactionsByOwnerQueryVariables>(GetTransactionsByOwnerDocument, variables, options) as Promise<GqlGetTransactionsByOwnerQuery>;
    },
    estimatePredicates(variables: GqlEstimatePredicatesQueryVariables, options?: C): Promise<GqlEstimatePredicatesQuery> {
      return requester<GqlEstimatePredicatesQuery, GqlEstimatePredicatesQueryVariables>(EstimatePredicatesDocument, variables, options) as Promise<GqlEstimatePredicatesQuery>;
    },
    estimatePredicatesAndGasPrice(variables: GqlEstimatePredicatesAndGasPriceQueryVariables, options?: C): Promise<GqlEstimatePredicatesAndGasPriceQuery> {
      return requester<GqlEstimatePredicatesAndGasPriceQuery, GqlEstimatePredicatesAndGasPriceQueryVariables>(EstimatePredicatesAndGasPriceDocument, variables, options) as Promise<GqlEstimatePredicatesAndGasPriceQuery>;
    },
    getLatestBlock(variables?: GqlGetLatestBlockQueryVariables, options?: C): Promise<GqlGetLatestBlockQuery> {
      return requester<GqlGetLatestBlockQuery, GqlGetLatestBlockQueryVariables>(GetLatestBlockDocument, variables, options) as Promise<GqlGetLatestBlockQuery>;
    },
    getLatestBlockHeight(variables?: GqlGetLatestBlockHeightQueryVariables, options?: C): Promise<GqlGetLatestBlockHeightQuery> {
      return requester<GqlGetLatestBlockHeightQuery, GqlGetLatestBlockHeightQueryVariables>(GetLatestBlockHeightDocument, variables, options) as Promise<GqlGetLatestBlockHeightQuery>;
    },
    getBlock(variables?: GqlGetBlockQueryVariables, options?: C): Promise<GqlGetBlockQuery> {
      return requester<GqlGetBlockQuery, GqlGetBlockQueryVariables>(GetBlockDocument, variables, options) as Promise<GqlGetBlockQuery>;
    },
    getBlockWithTransactions(variables?: GqlGetBlockWithTransactionsQueryVariables, options?: C): Promise<GqlGetBlockWithTransactionsQuery> {
      return requester<GqlGetBlockWithTransactionsQuery, GqlGetBlockWithTransactionsQueryVariables>(GetBlockWithTransactionsDocument, variables, options) as Promise<GqlGetBlockWithTransactionsQuery>;
    },
    getBlocks(variables?: GqlGetBlocksQueryVariables, options?: C): Promise<GqlGetBlocksQuery> {
      return requester<GqlGetBlocksQuery, GqlGetBlocksQueryVariables>(GetBlocksDocument, variables, options) as Promise<GqlGetBlocksQuery>;
    },
    getCoin(variables: GqlGetCoinQueryVariables, options?: C): Promise<GqlGetCoinQuery> {
      return requester<GqlGetCoinQuery, GqlGetCoinQueryVariables>(GetCoinDocument, variables, options) as Promise<GqlGetCoinQuery>;
    },
    getCoins(variables: GqlGetCoinsQueryVariables, options?: C): Promise<GqlGetCoinsQuery> {
      return requester<GqlGetCoinsQuery, GqlGetCoinsQueryVariables>(GetCoinsDocument, variables, options) as Promise<GqlGetCoinsQuery>;
    },
    getCoinsToSpend(variables: GqlGetCoinsToSpendQueryVariables, options?: C): Promise<GqlGetCoinsToSpendQuery> {
      return requester<GqlGetCoinsToSpendQuery, GqlGetCoinsToSpendQueryVariables>(GetCoinsToSpendDocument, variables, options) as Promise<GqlGetCoinsToSpendQuery>;
    },
    getContract(variables: GqlGetContractQueryVariables, options?: C): Promise<GqlGetContractQuery> {
      return requester<GqlGetContractQuery, GqlGetContractQueryVariables>(GetContractDocument, variables, options) as Promise<GqlGetContractQuery>;
    },
    getContractBalance(variables: GqlGetContractBalanceQueryVariables, options?: C): Promise<GqlGetContractBalanceQuery> {
      return requester<GqlGetContractBalanceQuery, GqlGetContractBalanceQueryVariables>(GetContractBalanceDocument, variables, options) as Promise<GqlGetContractBalanceQuery>;
    },
    getBalance(variables: GqlGetBalanceQueryVariables, options?: C): Promise<GqlGetBalanceQuery> {
      return requester<GqlGetBalanceQuery, GqlGetBalanceQueryVariables>(GetBalanceDocument, variables, options) as Promise<GqlGetBalanceQuery>;
    },
    getBalanceV2(variables: GqlGetBalanceV2QueryVariables, options?: C): Promise<GqlGetBalanceV2Query> {
      return requester<GqlGetBalanceV2Query, GqlGetBalanceV2QueryVariables>(GetBalanceV2Document, variables, options) as Promise<GqlGetBalanceV2Query>;
    },
    getLatestGasPrice(variables?: GqlGetLatestGasPriceQueryVariables, options?: C): Promise<GqlGetLatestGasPriceQuery> {
      return requester<GqlGetLatestGasPriceQuery, GqlGetLatestGasPriceQueryVariables>(GetLatestGasPriceDocument, variables, options) as Promise<GqlGetLatestGasPriceQuery>;
    },
    estimateGasPrice(variables: GqlEstimateGasPriceQueryVariables, options?: C): Promise<GqlEstimateGasPriceQuery> {
      return requester<GqlEstimateGasPriceQuery, GqlEstimateGasPriceQueryVariables>(EstimateGasPriceDocument, variables, options) as Promise<GqlEstimateGasPriceQuery>;
    },
    getBalances(variables: GqlGetBalancesQueryVariables, options?: C): Promise<GqlGetBalancesQuery> {
      return requester<GqlGetBalancesQuery, GqlGetBalancesQueryVariables>(GetBalancesDocument, variables, options) as Promise<GqlGetBalancesQuery>;
    },
    getBalancesV2(variables: GqlGetBalancesV2QueryVariables, options?: C): Promise<GqlGetBalancesV2Query> {
      return requester<GqlGetBalancesV2Query, GqlGetBalancesV2QueryVariables>(GetBalancesV2Document, variables, options) as Promise<GqlGetBalancesV2Query>;
    },
    getMessages(variables: GqlGetMessagesQueryVariables, options?: C): Promise<GqlGetMessagesQuery> {
      return requester<GqlGetMessagesQuery, GqlGetMessagesQueryVariables>(GetMessagesDocument, variables, options) as Promise<GqlGetMessagesQuery>;
    },
    daCompressedBlock(variables: GqlDaCompressedBlockQueryVariables, options?: C): Promise<GqlDaCompressedBlockQuery> {
      return requester<GqlDaCompressedBlockQuery, GqlDaCompressedBlockQueryVariables>(DaCompressedBlockDocument, variables, options) as Promise<GqlDaCompressedBlockQuery>;
    },
    getMessageProof(variables: GqlGetMessageProofQueryVariables, options?: C): Promise<GqlGetMessageProofQuery> {
      return requester<GqlGetMessageProofQuery, GqlGetMessageProofQueryVariables>(GetMessageProofDocument, variables, options) as Promise<GqlGetMessageProofQuery>;
    },
    getMessageStatus(variables: GqlGetMessageStatusQueryVariables, options?: C): Promise<GqlGetMessageStatusQuery> {
      return requester<GqlGetMessageStatusQuery, GqlGetMessageStatusQueryVariables>(GetMessageStatusDocument, variables, options) as Promise<GqlGetMessageStatusQuery>;
    },
    getRelayedTransactionStatus(variables: GqlGetRelayedTransactionStatusQueryVariables, options?: C): Promise<GqlGetRelayedTransactionStatusQuery> {
      return requester<GqlGetRelayedTransactionStatusQuery, GqlGetRelayedTransactionStatusQueryVariables>(GetRelayedTransactionStatusDocument, variables, options) as Promise<GqlGetRelayedTransactionStatusQuery>;
    },
    getAssetDetails(variables: GqlGetAssetDetailsQueryVariables, options?: C): Promise<GqlGetAssetDetailsQuery> {
      return requester<GqlGetAssetDetailsQuery, GqlGetAssetDetailsQueryVariables>(GetAssetDetailsDocument, variables, options) as Promise<GqlGetAssetDetailsQuery>;
    },
    assembleTx(variables: GqlAssembleTxQueryVariables, options?: C): Promise<GqlAssembleTxQuery> {
      return requester<GqlAssembleTxQuery, GqlAssembleTxQueryVariables>(AssembleTxDocument, variables, options) as Promise<GqlAssembleTxQuery>;
    },
    dryRun(variables: GqlDryRunQueryVariables, options?: C): Promise<GqlDryRunQuery> {
      return requester<GqlDryRunQuery, GqlDryRunQueryVariables>(DryRunDocument, variables, options) as Promise<GqlDryRunQuery>;
    },
    submit(variables: GqlSubmitMutationVariables, options?: C): Promise<GqlSubmitMutation> {
      return requester<GqlSubmitMutation, GqlSubmitMutationVariables>(SubmitDocument, variables, options) as Promise<GqlSubmitMutation>;
    },
    produceBlocks(variables: GqlProduceBlocksMutationVariables, options?: C): Promise<GqlProduceBlocksMutation> {
      return requester<GqlProduceBlocksMutation, GqlProduceBlocksMutationVariables>(ProduceBlocksDocument, variables, options) as Promise<GqlProduceBlocksMutation>;
    },
    getMessageByNonce(variables: GqlGetMessageByNonceQueryVariables, options?: C): Promise<GqlGetMessageByNonceQuery> {
      return requester<GqlGetMessageByNonceQuery, GqlGetMessageByNonceQueryVariables>(GetMessageByNonceDocument, variables, options) as Promise<GqlGetMessageByNonceQuery>;
    },
    isUserAccount(variables: GqlIsUserAccountQueryVariables, options?: C): Promise<GqlIsUserAccountQuery> {
      return requester<GqlIsUserAccountQuery, GqlIsUserAccountQueryVariables>(IsUserAccountDocument, variables, options) as Promise<GqlIsUserAccountQuery>;
    },
    getConsensusParametersVersion(variables?: GqlGetConsensusParametersVersionQueryVariables, options?: C): Promise<GqlGetConsensusParametersVersionQuery> {
      return requester<GqlGetConsensusParametersVersionQuery, GqlGetConsensusParametersVersionQueryVariables>(GetConsensusParametersVersionDocument, variables, options) as Promise<GqlGetConsensusParametersVersionQuery>;
    },
    submitAndAwaitStatus(variables: GqlSubmitAndAwaitStatusSubscriptionVariables, options?: C): AsyncIterable<GqlSubmitAndAwaitStatusSubscription> {
      return requester<GqlSubmitAndAwaitStatusSubscription, GqlSubmitAndAwaitStatusSubscriptionVariables>(SubmitAndAwaitStatusDocument, variables, options) as AsyncIterable<GqlSubmitAndAwaitStatusSubscription>;
    },
    statusChange(variables: GqlStatusChangeSubscriptionVariables, options?: C): AsyncIterable<GqlStatusChangeSubscription> {
      return requester<GqlStatusChangeSubscription, GqlStatusChangeSubscriptionVariables>(StatusChangeDocument, variables, options) as AsyncIterable<GqlStatusChangeSubscription>;
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;